import qs from 'qs';
import { getUserDeviceId } from '@gaoding/user-device-id';
import { platform as platform$1 } from '@gdesign/platform';
import axios from 'axios';
import Cookies from 'js-cookie';
import { Base64 } from 'js-base64';
import { localCache } from '@gaoding/cache';
import AES from 'crypto-js/aes.js';
import ECB from 'crypto-js/mode-ecb.js';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

var getHttpHeadsAdapter = platform$1.extend({
    // @ts-ignore
    isGaodingApp: function () {
        return __awaiter(this, void 0, void 0, function () {
            var bridge, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, platform$1.resolveCurrentModuleAdapter()];
                    case 1:
                        bridge = (_a.sent()).bridge;
                        return [2 /*return*/, bridge.call('getHttpHeads')];
                    case 2:
                        error_1 = _a.sent();
                        console.log('AppTokenSource::: get accessToken from bridge.call("getHttpHeads") error ==>', error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
});
var platform = platform$1;

var Env;
(function (Env) {
    Env["Dev"] = "dev";
    Env["Stage"] = "stage";
    Env["Prod"] = "prod";
    Env["Fat"] = "fat";
})(Env || (Env = {}));
var TokenSourceType;
(function (TokenSourceType) {
    TokenSourceType["LocalStorage"] = "localStorage";
    TokenSourceType["LocalStorageForce"] = "localStorageForce";
    TokenSourceType["Iframe"] = "iframe";
    TokenSourceType["IframeForce"] = "iframeForce";
    TokenSourceType["Electron"] = "electron";
    TokenSourceType["WebApp"] = "webApp";
    TokenSourceType["Huaban"] = "huaban";
    TokenSourceType["Memory"] = "memory";
})(TokenSourceType || (TokenSourceType = {}));

function paddingProtocol(url) {
    if (url.startsWith('http')) {
        return url;
    }
    if (typeof location !== 'undefined' && location.protocol.startsWith('http')) {
        return location.protocol + "//" + url;
    }
    return "https://" + url;
}

var host = function () {
    if (typeof window === 'undefined') {
        return 'gaoding.com';
    }
    if (window.location.host.includes('localhost')) {
        return 'gaoding.com';
    }
    if (!location.host.endsWith('.gaoding.com')) {
        return location.host.split('.').slice(-2).join('.');
    }
    return 'gaoding.com';
};
var umsHost = 'gaoding.com';
var host$1 = host();

var _a;
var TOKEN_KEY = 'token';
var ORG_ID_KEY = 'token.org_id';
var EXTRA_DATA = 'UMS_EXTRA_DATA__';
var REFRESHING_TOKEN_KEY = 'refreshing_token';
var TIME_FACTOR = 30 * 1000;
var inBrowser = typeof window !== 'undefined';
var DEFAULT_CLIENTID = 'gaodingx';
var DEFAULT_CLIENTIDS = [DEFAULT_CLIENTID, 'ums', 'open_platform', 'saas', 'huaban'];
var envConfigMap = (_a = {},
    _a[Env.Dev] = {
        clientId: DEFAULT_CLIENTID,
        clientSecret: '7da458070e57b98e11d00d9286f23537',
        tokenEndpoint: paddingProtocol("ums.dev." + umsHost + "/connect/oauth/tokens"),
        tokenEndpointV3: paddingProtocol("ums.dev." + umsHost + "/v3/connect/oauth/tokens"),
        authorizationEndpoint: paddingProtocol("ums.dev." + umsHost + "/oauth2/authorize"),
        redirectURI: paddingProtocol("dev." + host$1 + "/api/ums/redirect"),
        iframeTokenSourceURL: paddingProtocol("ums.dev." + umsHost + "/oauth2/source"),
        qiyeSsoURI: paddingProtocol("sso.my-dev." + umsHost),
        umsURI: paddingProtocol("ums.dev." + umsHost),
        umsAuthURIOld: paddingProtocol("ums.dev." + umsHost + "/ums/auth"),
        umsAuthURI: paddingProtocol("ums.dev." + umsHost + "/ums/cgi/sso"),
    },
    _a[Env.Fat] = {
        clientId: DEFAULT_CLIENTID,
        clientSecret: '7da458070e57b98e11d00d9286f23537',
        tokenEndpoint: paddingProtocol("ums-fat." + umsHost + "/connect/oauth/tokens"),
        tokenEndpointV3: paddingProtocol("ums-fat." + umsHost + "/v3/connect/oauth/tokens"),
        authorizationEndpoint: paddingProtocol("ums-fat." + umsHost + "/oauth2/authorize"),
        redirectURI: paddingProtocol("fat." + host$1 + "/api/ums/redirect"),
        iframeTokenSourceURL: paddingProtocol("ums-fat." + umsHost + "/oauth2/source"),
        qiyeSsoURI: paddingProtocol("sso.my-fat." + umsHost),
        umsURI: paddingProtocol("ums-fat." + umsHost),
        umsAuthURIOld: paddingProtocol("ums-fat." + umsHost + "/ums/auth"),
        umsAuthURI: paddingProtocol("ums-fat." + umsHost + "/ums/cgi/sso"),
    },
    _a[Env.Stage] = {
        clientId: DEFAULT_CLIENTID,
        clientSecret: '7da458070e57b98e11d00d9286f23537',
        tokenEndpoint: paddingProtocol("ums-stage." + umsHost + "/connect/oauth/tokens"),
        tokenEndpointV3: paddingProtocol("ums-stage." + umsHost + "/v3/connect/oauth/tokens"),
        authorizationEndpoint: paddingProtocol("ums-stage." + umsHost + "/oauth2/authorize"),
        redirectURI: paddingProtocol("stage." + host$1 + "/api/ums/redirect"),
        iframeTokenSourceURL: paddingProtocol("ums-stage." + umsHost + "/oauth2/source"),
        qiyeSsoURI: paddingProtocol("sso.my-stage." + umsHost),
        umsURI: paddingProtocol("ums-stage." + umsHost),
        umsAuthURIOld: paddingProtocol("ums-stage." + umsHost + "/ums/auth"),
        umsAuthURI: paddingProtocol("ums-stage." + umsHost + "/ums/cgi/sso"),
    },
    _a[Env.Prod] = {
        clientId: DEFAULT_CLIENTID,
        clientSecret: '7da458070e57b98e11d00d9286f23537',
        tokenEndpoint: paddingProtocol("ums." + umsHost + "/connect/oauth/tokens"),
        tokenEndpointV3: paddingProtocol("ums." + umsHost + "/v3/connect/oauth/tokens"),
        authorizationEndpoint: paddingProtocol("ums." + umsHost + "/oauth2/authorize"),
        redirectURI: paddingProtocol("www." + host$1 + "/api/ums/redirect"),
        iframeTokenSourceURL: paddingProtocol("ums." + umsHost + "/oauth2/source"),
        qiyeSsoURI: paddingProtocol("sso.my." + umsHost),
        umsURI: paddingProtocol("ums." + umsHost),
        umsAuthURIOld: paddingProtocol("ums." + umsHost + "/ums/auth"),
        umsAuthURI: paddingProtocol("ums." + umsHost + "/ums/cgi/sso"),
    },
    _a);
var AUTH_LOGOUT_STATUS = 'auth_next_logout_status';
var TOKEN_STATUS = function (version) {
    if (version === void 0) { version = 'v0.9.0'; }
    var CDN_URL = "https://cdn.dancf.com/packages/gaoding/auth-widget/" + version;
    return {
        scramble: '1002023',
        scrambleDialogUrl: CDN_URL + "/dialog-scramble.js",
        risk: '1002026',
        riskDialogUrl: CDN_URL + "/dialog-risk.js",
        freeze: '1002027',
        freezeDialogUrl: CDN_URL + "/dialog-freeze.js",
        // 登录提示（用户注销状态提示）
        logoutDialogUrl: CDN_URL + "/dialog-logout.js",
    };
};
/**
 * 0-未提交, 1-注销中, 2-已撤销，3-已注销
 */
var USER_DESTROY_STATUS;
(function (USER_DESTROY_STATUS) {
    USER_DESTROY_STATUS[USER_DESTROY_STATUS["NotSubmitted"] = 0] = "NotSubmitted";
    USER_DESTROY_STATUS[USER_DESTROY_STATUS["Unregistering"] = 1] = "Unregistering";
    USER_DESTROY_STATUS[USER_DESTROY_STATUS["Revoked"] = 3] = "Revoked";
    USER_DESTROY_STATUS[USER_DESTROY_STATUS["Unregistered"] = 4] = "Unregistered";
})(USER_DESTROY_STATUS || (USER_DESTROY_STATUS = {}));
var ENDPOINT = {
    'IOS': '1',
    'ANDROID': '2',
    'H5': '3',
    'WEB': '4',
    'ELECTRON': '28',
};

function snakeCaseKeys(o) {
    var keys = Object.keys(o);
    var result = {};
    keys.forEach(function (key) {
        var snakeCaseKey = key.replace(/([a-z])([A-Z])/g, function (m, a, b) { return a + '_' + b.toLowerCase(); });
        result[snakeCaseKey] = o[key];
    });
    return result;
}

var AccessTokenRequest = /** @class */ (function () {
    function AccessTokenRequest(params) {
        this.params = params;
    }
    AccessTokenRequest.prototype.toSnakeCase = function () {
        return snakeCaseKeys(this.params);
    };
    return AccessTokenRequest;
}());
var PasswordRequest = /** @class */ (function (_super) {
    __extends(PasswordRequest, _super);
    function PasswordRequest(params) {
        var _this = _super.call(this, params) || this;
        _this.params = params;
        return _this;
    }
    return PasswordRequest;
}(AccessTokenRequest));
var VerifyCodeRequest = /** @class */ (function (_super) {
    __extends(VerifyCodeRequest, _super);
    function VerifyCodeRequest(params) {
        var _this = _super.call(this, params) || this;
        _this.params = params;
        return _this;
    }
    return VerifyCodeRequest;
}(AccessTokenRequest));
var AuthorizationCodeRequest = /** @class */ (function (_super) {
    __extends(AuthorizationCodeRequest, _super);
    function AuthorizationCodeRequest(params) {
        var _this = _super.call(this, params) || this;
        _this.params = params;
        return _this;
    }
    return AuthorizationCodeRequest;
}(AccessTokenRequest));
var ThirdPartyRequest = /** @class */ (function (_super) {
    __extends(ThirdPartyRequest, _super);
    function ThirdPartyRequest(params) {
        var _this = _super.call(this, params) || this;
        _this.params = params;
        return _this;
    }
    return ThirdPartyRequest;
}(AccessTokenRequest));
var RefreshTokenRequest = /** @class */ (function (_super) {
    __extends(RefreshTokenRequest, _super);
    function RefreshTokenRequest(params) {
        var _this = _super.call(this, params) || this;
        _this.params = params;
        return _this;
    }
    return RefreshTokenRequest;
}(AccessTokenRequest));
var RefreshOrgIdRequest = /** @class */ (function () {
    function RefreshOrgIdRequest(params) {
        this.params = params;
        this.params = params;
    }
    RefreshOrgIdRequest.prototype.toSnakeCase = function () {
        return snakeCaseKeys(this.params);
    };
    return RefreshOrgIdRequest;
}());

function getOS() {
    if (typeof navigator !== 'object') {
        return 'unknown';
    }
    var platform = navigator.platform.toLowerCase();
    if (platform === 'win32' || platform === 'windows') {
        return 'windows';
    }
    if (platform.includes('mac')) {
        return 'mac os';
    }
    if (platform === 'x11') {
        return 'unix';
    }
    if (platform.includes('linux')) {
        return 'linux';
    }
    return 'unknown';
}

function isMobile() {
    return /Android|Mobi|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}
function isAndroid() {
    return /Android/i.test(navigator.userAgent);
}
function isIOS() {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}

var scriptLoadCache = {};
function loadScript(url) {
    if (scriptLoadCache[url]) {
        return scriptLoadCache[url];
    }
    scriptLoadCache[url] = new Promise(function (resolve, reject) {
        var hasLoaded = document.querySelector("script[src='" + url + "']");
        if (hasLoaded) {
            resolve(null);
        }
        var script = document.createElement('script');
        script.src = url;
        script.async = true;
        script.onload = function () { return resolve(null); };
        script.onerror = function () { return reject(new Error("Failed to load script: " + url)); };
        document.head.appendChild(script);
    });
    return scriptLoadCache[url];
}

/**
 * https://npm.gaoding.com/package/@gaoding/auth-widget
 */
var launchDialog = (function (checkOptions, error) {
    if (checkOptions === void 0) { checkOptions = {}; }
    return __awaiter(void 0, void 0, void 0, function () {
        var code, tokenStatus, config, detail, config, config;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    code = String(error && (error.code || error.error_code));
                    tokenStatus = TOKEN_STATUS(checkOptions.version);
                    if (!(code === tokenStatus.scramble)) return [3 /*break*/, 2];
                    return [4 /*yield*/, loadScript(tokenStatus.scrambleDialogUrl)];
                case 1:
                    _a.sent();
                    config = checkOptions.scramble;
                    detail = error && error.detail;
                    // @ts-ignore
                    window.AUTH_WIDGET_SCRAMBLE && window.AUTH_WIDGET_SCRAMBLE.mount(Object.assign({ props: detail }, config));
                    return [2 /*return*/];
                case 2:
                    if (!(code === tokenStatus.risk)) return [3 /*break*/, 4];
                    return [4 /*yield*/, loadScript(tokenStatus.riskDialogUrl)];
                case 3:
                    _a.sent();
                    config = checkOptions.risk;
                    // @ts-ignore
                    window.AUTH_WIDGET_RISK && window.AUTH_WIDGET_RISK.mount(config);
                    return [2 /*return*/];
                case 4:
                    if (!(code === tokenStatus.freeze)) return [3 /*break*/, 6];
                    return [4 /*yield*/, loadScript(tokenStatus.freezeDialogUrl)];
                case 5:
                    _a.sent();
                    config = checkOptions.freeze;
                    // @ts-ignore
                    window.AUTH_WIDGET_FREEZE && window.AUTH_WIDGET_FREEZE.mount(config);
                    return [2 /*return*/];
                case 6: throw error;
            }
        });
    });
});
var logoutDialog = function (config) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, loadScript(TOKEN_STATUS().logoutDialogUrl)];
            case 1:
                _a.sent();
                // @ts-ignore
                window.AUTH_WIDGET_LOGOUT && window.AUTH_WIDGET_LOGOUT.mount(config);
                return [2 /*return*/];
        }
    });
}); };

var http = axios.create({
    withCredentials: true,
});
http.interceptors.response.use(function (response) { return response; }, function (error) {
    if (error.response) {
        var response = error.response;
        if (response.data) {
            return Promise.reject(response.data);
        }
        var err = new Error(response.status + response.statusText);
        err.status = response.status;
        return Promise.reject(err);
    }
    return Promise.reject(error);
});

var logger = (function (data) {
    var _a;
    if (typeof window !== 'undefined' && ((_a = window.__GD_SLS_RUM) === null || _a === void 0 ? void 0 : _a.addLog)) {
        window.__GD_SLS_RUM.addLog.push(__assign({ type: 'o2c_sdk' }, data));
    }
});

var DEFAULT_DOMAIN = host$1;
/**
 * https://doc.huanleguang.com/pages/viewpage.action?pageId=220571495
 * 暂时只支持往 gaodingx 种 cookie
 */
var Cookie = /** @class */ (function () {
    function Cookie(client, tokenKey) {
        this.isDefaultClient = false; // gaodingx
        this.tokenKey = '';
        this.domain = '';
        var _a = client.config, env = _a.env, clientId = _a.clientId, _b = _a.domain, domain = _b === void 0 ? DEFAULT_DOMAIN : _b, _c = _a.samesite, samesite = _c === void 0 ? 'none' : _c;
        this.tokenKey = tokenKey + "." + env;
        this.samesite = samesite;
        this.domain = domain === null || domain === void 0 ? void 0 : domain.split(':')[0];
        if (DEFAULT_CLIENTIDS.includes(clientId)) {
            this.isDefaultClient = true;
        }
    }
    Cookie.prototype.set = function (key, value, options) {
        if (!this.isDefaultClient) {
            return;
        }
        var _options = Object.assign({ domain: this.domain }, options);
        if (this.samesite) {
            _options = Object.assign({ samesite: this.samesite }, _options);
        }
        if (this.samesite === 'none') {
            _options = Object.assign({ secure: true }, _options);
        }
        this.addLog({ key: key, value: value, options: options });
        // @FIXME: 移除诡异的 token 种在 ums.gaoding.com 上的问题
        Cookies.remove(key);
        Cookies.set(key, value, _options);
    };
    Cookie.prototype.get = function (key) {
        if (!this.isDefaultClient) {
            return;
        }
        return Cookies.get(key) || '';
    };
    Cookie.prototype.clear = function (key) {
        if (!this.isDefaultClient) {
            return;
        }
        var _options = { domain: this.domain };
        if (this.samesite === 'none') {
            _options = Object.assign(_options, { samesite: this.samesite, secure: true });
        }
        Cookies.remove(key, _options);
    };
    Cookie.prototype.setToken = function (token) {
        if (!this.isDefaultClient) {
            return;
        }
        try {
            var expires = void 0;
            var _token = JSON.parse(token);
            if (_token === null || _token === void 0 ? void 0 : _token.refresh_token_expires_at) {
                expires = new Date(_token.refresh_token_expires_at);
            }
            this.set(this.tokenKey, Base64.encode(token), { expires: expires });
        }
        catch (error) {
            // eslint-disable-next-line no-console
        }
    };
    Cookie.prototype.getToken = function () {
        if (!this.isDefaultClient) {
            return;
        }
        var ck = this.get(this.tokenKey) || '';
        return Base64.decode(ck);
    };
    Cookie.prototype.setOrgId = function (key, val) {
        this.set(key, val, { expires: 15 });
    };
    Cookie.prototype.getOrgId = function (key) {
        return this.get(key) || '';
    };
    Cookie.prototype.clearToken = function () {
        if (!this.isDefaultClient) {
            return;
        }
        this.clear(this.tokenKey);
    };
    Cookie.prototype.addLog = function (data) {
        var _a, _b;
        if ((_b = (_a = data.options) === null || _a === void 0 ? void 0 : _a.domain) === null || _b === void 0 ? void 0 : _b.endsWith('ums.gaoding.com')) {
            logger(data);
        }
    };
    return Cookie;
}());

var isMergeAccount = (function (client) {
    var clientId = client.config.clientId;
    var _tokenKey = TOKEN_KEY;
    if (client.config.scopeToken) {
        _tokenKey = clientId + "." + TOKEN_KEY;
    }
    if (client.config.tokenKey) {
        _tokenKey = client.config.tokenKey;
    }
    var _cookie = new Cookie(client, _tokenKey);
    var ckToken = _cookie.getToken();
    var lStoken = localStorage.getItem(_tokenKey) || '';
    try {
        if (ckToken) {
            var parsed = JSON.parse(ckToken);
            return parsed.merged;
        }
        if (lStoken) {
            var parsed = JSON.parse(lStoken);
            return parsed.merged;
        }
    }
    catch (error) {
        return null;
    }
});

function sleep(timeout) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve) {
                    setTimeout(function () {
                        resolve();
                    }, timeout);
                })];
        });
    });
}

var TIMEOUT = 30;
var LocalStorageTokenSource = /** @class */ (function () {
    function LocalStorageTokenSource(client) {
        var _this = this;
        this.client = client;
        this._queue = [];
        this.logStack = [];
        this.tokenCache = null;
        this.orgIdCache = null;
        this._listenRefreshingTokenChange = function (event) { return __awaiter(_this, void 0, void 0, function () {
            var key, newValue, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        key = event.key, newValue = event.newValue;
                        if (key === null) {
                            this._flushRefreshTokenQueue(null);
                            return [2 /*return*/];
                        }
                        if (key !== this._refreshingTokenKey) {
                            return [2 /*return*/];
                        }
                        if (!(newValue === null)) return [3 /*break*/, 2];
                        this._log('Other client end refreshing token.');
                        _a = this._flushRefreshTokenQueue;
                        _b = [null];
                        return [4 /*yield*/, this._getToken()];
                    case 1:
                        _a.apply(this, _b.concat([_c.sent()]));
                        this._clearRefreshTokenTimeout();
                        return [2 /*return*/];
                    case 2:
                        this._log('Other client start refreshing token.');
                        return [2 /*return*/];
                }
            });
        }); };
        var _a = client.config, env = _a.env, clientId = _a.clientId;
        this._tokenKey = TOKEN_KEY;
        this._orgId = ORG_ID_KEY + "." + env;
        if (client.config.scopeToken) {
            this._tokenKey = clientId + "." + TOKEN_KEY;
        }
        if (client.config.tokenKey) {
            this._tokenKey = client.config.tokenKey;
            this._orgId = client.config.tokenKey + ".org_id." + env;
        }
        if (client.config.refreshingTokenKey) {
            this._refreshingTokenKey = client.config.refreshingTokenKey;
        }
        if (!client.config.refreshingTokenKey && client.config.tokenSourceType === TokenSourceType.LocalStorage) {
            this._refreshingTokenKey = REFRESHING_TOKEN_KEY;
        }
        else {
            this._refreshingTokenKey = clientId + "." + REFRESHING_TOKEN_KEY;
        }
        this._cookie = new Cookie(client, this._tokenKey);
        (typeof window !== 'undefined') && window.addEventListener('storage', this._listenRefreshingTokenChange, false);
        this._init();
    }
    LocalStorageTokenSource.prototype.getAccessToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var isRefreshingToken, token, accessToken, accessTokenExpiresIn, accessTokenLifeTime, accessTokenExpiresAt, refreshToken, refreshTokenExpiresIn, refreshTokenLifeTime, refreshTokenExpiresAt, timestamp;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._log('Getting access token...[LOG_SKIP]');
                        isRefreshingToken = this._isRefreshingToken();
                        if (isRefreshingToken) {
                            this._log('Refreshing token...[LOG_SKIP]');
                            return [2 /*return*/, new Promise(function (resolve, reject) {
                                    _this._queue.push({
                                        fulfilled: resolve,
                                        rejected: reject
                                    });
                                })];
                        }
                        return [4 /*yield*/, this._getToken()];
                    case 1:
                        token = _a.sent();
                        if (!token) {
                            this._log('Token is empty.');
                            return [2 /*return*/];
                        }
                        accessToken = token.access_token;
                        accessTokenExpiresIn = token.expires_in;
                        accessTokenLifeTime = token.access_token_life_time;
                        accessTokenExpiresAt = token.access_token_expires_at;
                        refreshToken = token.refresh_token;
                        refreshTokenExpiresIn = token.refresh_token_expires_in;
                        refreshTokenLifeTime = token.refresh_token_life_time;
                        refreshTokenExpiresAt = token.refresh_token_expires_at;
                        timestamp = token.timestamp;
                        if (accessToken &&
                            !this._tokenIsExpired(timestamp, accessTokenLifeTime || accessTokenExpiresIn, accessTokenExpiresAt)) {
                            this._log('Access token:', accessToken);
                            return [2 /*return*/, accessToken];
                        }
                        this._log('Access token expired.');
                        if (!refreshToken ||
                            this._tokenIsExpired(timestamp, refreshTokenLifeTime || refreshTokenExpiresIn, refreshTokenExpiresAt)) {
                            this.clearToken('IS_EXPIRED');
                            this._log('Refresh token expired.');
                            return [2 /*return*/];
                        }
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                _this._queue.push({
                                    fulfilled: resolve,
                                    rejected: reject
                                });
                                _this._handleRefreshToken(token);
                            })];
                }
            });
        });
    };
    LocalStorageTokenSource.prototype._tokenIsExpired = function (timestamp, lifeTime, expiresAt) {
        if (timestamp && lifeTime) {
            return timestamp + lifeTime * 1000 < Date.now() + TIME_FACTOR;
        }
        if (expiresAt) {
            return Date.parse(expiresAt) < Date.now() + TIME_FACTOR;
        }
        return true;
    };
    LocalStorageTokenSource.prototype.getToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._getToken()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LocalStorageTokenSource.prototype.setToken = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            var oldToken, _token, tokenStr;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getToken()
                        // 如果是一体化授权，补充 merged 字段
                    ];
                    case 1:
                        oldToken = _a.sent();
                        _token = (oldToken === null || oldToken === void 0 ? void 0 : oldToken.merged) ? Object.assign(token, { merged: true }) : token;
                        tokenStr = JSON.stringify(_token);
                        localCache.setItem(this._tokenKey, tokenStr);
                        this._cookie.setToken(tokenStr);
                        this.tokenCache = _token;
                        if (!(_token === null || _token === void 0 ? void 0 : _token.org_id)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.setOrgId(_token.org_id)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LocalStorageTokenSource.prototype.setOrgId = function (org_id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                localCache.setItem(this._orgId, org_id);
                this._cookie.setOrgId(this._orgId, org_id);
                this.orgIdCache = org_id;
                return [2 /*return*/];
            });
        });
    };
    LocalStorageTokenSource.prototype.getOrgId = function () {
        return __awaiter(this, void 0, void 0, function () {
            var ckOrgId, lSorgId;
            return __generator(this, function (_a) {
                ckOrgId = this._cookie.getOrgId(this._orgId);
                lSorgId = localCache.getItem(this._orgId);
                if (ckOrgId) {
                    localCache.setItem(this._orgId, ckOrgId);
                    this.orgIdCache = ckOrgId;
                }
                if (lSorgId && !ckOrgId) {
                    this._cookie.setOrgId(this._orgId, lSorgId);
                    this.orgIdCache = lSorgId;
                }
                return [2 /*return*/, ckOrgId || lSorgId || this.orgIdCache || ''];
            });
        });
    };
    LocalStorageTokenSource.prototype.setExtraData = function (key, data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                localCache.setItem("" + EXTRA_DATA + key, JSON.stringify(data));
                return [2 /*return*/];
            });
        });
    };
    LocalStorageTokenSource.prototype.getExtraData = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            var extraData, parsed;
            return __generator(this, function (_a) {
                extraData = localCache.getItem("" + EXTRA_DATA + key);
                if (extraData) {
                    try {
                        parsed = JSON.parse(extraData);
                        return [2 /*return*/, parsed];
                        /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
                    }
                    catch (error) {
                        // ignore error
                        return [2 /*return*/, null];
                    }
                }
                return [2 /*return*/, null];
            });
        });
    };
    LocalStorageTokenSource.prototype.clearToken = function (state) {
        return __awaiter(this, void 0, void 0, function () {
            var token, access_token, isSuccessDelToken;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getToken()];
                    case 1:
                        token = _a.sent();
                        access_token = (token === null || token === void 0 ? void 0 : token.access_token) || '';
                        if (state === 'IS_EXPIRED') {
                            localCache.removeItem(this._tokenKey);
                            localCache.removeItem(this._orgId);
                            this._cookie.clearToken();
                            this.tokenCache = null;
                            this.orgIdCache = null;
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.client.launchreClearToken({ access_token: access_token })];
                    case 2:
                        isSuccessDelToken = _a.sent();
                        if (isSuccessDelToken) {
                            localCache.removeItem(this._tokenKey);
                            localCache.removeItem(this._orgId);
                            this._cookie.clearToken();
                            this.tokenCache = null;
                            this.orgIdCache = null;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    LocalStorageTokenSource.prototype._startRefreshToken = function () {
        this._log('Start refreshing token.');
        localCache.setItem(this._refreshingTokenKey, '1');
    };
    LocalStorageTokenSource.prototype._endRefreshToken = function () {
        this._log('End refreshing token.');
        localCache.removeItem(this._refreshingTokenKey);
    };
    LocalStorageTokenSource.prototype._init = function () {
        var isRefreshingToken = this._isRefreshingToken();
        if (isRefreshingToken) {
            this._handleRefreshTokenTimeout();
        }
    };
    LocalStorageTokenSource.prototype._getToken = function () {
        var ckToken = this._cookie.getToken();
        var lStoken = localCache.getItem(this._tokenKey) || '';
        try {
            // 同步 cookie token 到 localStorage
            if (ckToken) {
                localCache.setItem(this._tokenKey, ckToken);
                var parsed = JSON.parse(ckToken);
                this.tokenCache = parsed;
                return parsed;
            }
            // 同步 localStorage token 到 cookie
            if (lStoken) {
                this._cookie.setToken(lStoken);
                var parsed = JSON.parse(lStoken);
                this.tokenCache = parsed;
                return parsed;
            }
            return this.tokenCache || null;
        }
        catch (error) {
            return null;
        }
    };
    LocalStorageTokenSource.prototype._isRefreshingToken = function () {
        var refreshingToken = localCache.getItem(this._refreshingTokenKey);
        return Boolean(refreshingToken);
    };
    LocalStorageTokenSource.prototype._flushRefreshTokenQueue = function (error, token) {
        return __awaiter(this, void 0, void 0, function () {
            var queue, status_1, newToken, newAccessToken, accessToken, action, fulfilled, rejected;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queue = this._queue;
                        this._log('Start flushing get access token queue.');
                        this._log('Queue length:', queue.length);
                        if (error) {
                            this._log('Flushing by error:', error);
                        }
                        this._log('Flushing by token:', token);
                        if (!(error === null || error === void 0 ? void 0 : error.status)) return [3 /*break*/, 4];
                        status_1 = error.status;
                        if (!/^4\d\d/.test(status_1)) return [3 /*break*/, 4];
                        if (!(status_1 === 400)) return [3 /*break*/, 3];
                        // 对于多浏览器标签页，存在使用同一个 refresh token 并发请求刷新 token 的情况，常见于同时刷新标签页。
                        // 并发刷新 token 会遇到以下情况：
                        // 1. 请求都为成功；
                        // 2. 存在至少一个请求成功，其它返回 invalid_refresh_token 错误。
                        //
                        // 当遇到 invalid_refresh_token 时，检查 token 是否已经刷新。
                        // 若 token 已刷新，则忽略错误。
                        this._log('Invalid_refresh_token error encountered.');
                        this._log('Sleeping 2s ...');
                        return [4 /*yield*/, sleep(2000)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this._getToken()];
                    case 2:
                        newToken = _a.sent();
                        newAccessToken = newToken === null || newToken === void 0 ? void 0 : newToken.access_token;
                        this._log('Get current access token:', newAccessToken);
                        this._log('Compare with previous access token:', this._oldAccessToken);
                        if (newAccessToken && newAccessToken !== this._oldAccessToken) {
                            this._log('Token had refreshed by other client.');
                            token = newToken;
                            error = null;
                        }
                        else {
                            this._log('Invalid_refresh_token error 400');
                            this.clearToken('IS_EXPIRED');
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        this._log("Invalid_refresh_token error " + status_1);
                        this.clearToken('IS_EXPIRED');
                        _a.label = 4;
                    case 4:
                        accessToken = token === null || token === void 0 ? void 0 : token.access_token;
                        while (queue.length) {
                            action = queue.shift();
                            if (!action) {
                                continue;
                            }
                            fulfilled = action.fulfilled, rejected = action.rejected;
                            if (error) {
                                rejected(error);
                            }
                            else {
                                fulfilled(accessToken);
                            }
                        }
                        this._log('End flushing get access token queue.');
                        return [2 /*return*/];
                }
            });
        });
    };
    LocalStorageTokenSource.prototype._clearRefreshTokenTimeout = function () {
        if (this._timer) {
            clearTimeout(this._timer);
            this._timer = undefined;
        }
    };
    LocalStorageTokenSource.prototype._handleRefreshToken = function (token, isInit) {
        return __awaiter(this, void 0, void 0, function () {
            var isRefreshingToken, orgId, headers, deviceId, newToken, currentToken, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        isRefreshingToken = this._isRefreshingToken();
                        if (!isInit && isRefreshingToken) {
                            return [2 /*return*/];
                        }
                        this._oldAccessToken = token.access_token;
                        this._startRefreshToken();
                        return [4 /*yield*/, this.getOrgId()];
                    case 1:
                        orgId = _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 14, , 16]);
                        headers = {};
                        deviceId = this.client.config.deviceId ? this.client.config.deviceId : getUserDeviceId();
                        if (deviceId) {
                            headers['X-Guest-Token'] = deviceId;
                        }
                        this._log('Handle Refresh token:', token.refresh_token);
                        return [4 /*yield*/, this.client.launchRefreshTokenFlow({ refreshToken: token.refresh_token }, headers)];
                    case 3:
                        newToken = _a.sent();
                        if (!(orgId && !this.client.config.noRreshOrgId)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.client.launchreRreshOrgIdFlow({
                                org_id: orgId,
                                access_token: newToken.access_token,
                                refresh_token: newToken.refresh_token
                            })];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5:
                        this._log('Receive new token:', newToken);
                        return [4 /*yield*/, this._getToken()];
                    case 6:
                        currentToken = _a.sent();
                        if (!(currentToken && newToken.refresh_token_expires_at && currentToken.refresh_token_expires_at)) return [3 /*break*/, 10];
                        if (!(Date.parse(newToken.refresh_token_expires_at) >= Date.parse(currentToken.refresh_token_expires_at))) return [3 /*break*/, 8];
                        this._log('New token is more fresh than current token.');
                        return [4 /*yield*/, this.setToken(newToken)];
                    case 7:
                        _a.sent();
                        return [3 /*break*/, 9];
                    case 8:
                        this._log('Current token is more fresh than new token.');
                        _a.label = 9;
                    case 9: return [3 /*break*/, 12];
                    case 10: return [4 /*yield*/, this.setToken(newToken)];
                    case 11:
                        _a.sent();
                        _a.label = 12;
                    case 12: return [4 /*yield*/, this._flushRefreshTokenQueue(null, newToken)];
                    case 13:
                        _a.sent();
                        return [3 /*break*/, 16];
                    case 14:
                        error_1 = _a.sent();
                        this._log('Refresh token error');
                        return [4 /*yield*/, this._flushRefreshTokenQueue(error_1)];
                    case 15:
                        _a.sent();
                        return [3 /*break*/, 16];
                    case 16:
                        this._oldAccessToken = undefined;
                        this._endRefreshToken();
                        return [2 /*return*/];
                }
            });
        });
    };
    LocalStorageTokenSource.prototype._retryRefreshToken = function (isInit) {
        return __awaiter(this, void 0, void 0, function () {
            var token, accessToken, accessTokenExpiresIn, accessTokenLifeTime, accessTokenExpiresAt, refreshToken, refreshTokenExpiresIn, refreshTokenLifeTime, refreshTokenExpiresAt, timestamp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._log('Start retry refreshing token.');
                        return [4 /*yield*/, this._getToken()];
                    case 1:
                        token = _a.sent();
                        accessToken = token === null || token === void 0 ? void 0 : token.access_token;
                        accessTokenExpiresIn = token === null || token === void 0 ? void 0 : token.expires_in;
                        accessTokenLifeTime = token === null || token === void 0 ? void 0 : token.access_token_life_time;
                        accessTokenExpiresAt = token === null || token === void 0 ? void 0 : token.access_token_expires_at;
                        refreshToken = token === null || token === void 0 ? void 0 : token.refresh_token;
                        refreshTokenExpiresIn = token === null || token === void 0 ? void 0 : token.refresh_token_expires_in;
                        refreshTokenLifeTime = token === null || token === void 0 ? void 0 : token.refresh_token_life_time;
                        refreshTokenExpiresAt = token === null || token === void 0 ? void 0 : token.refresh_token_expires_at;
                        timestamp = token === null || token === void 0 ? void 0 : token.timestamp;
                        if (accessToken &&
                            !this._tokenIsExpired(timestamp, accessTokenLifeTime || accessTokenExpiresIn, accessTokenExpiresAt)) {
                            this._flushRefreshTokenQueue(null, token);
                            this._endRefreshToken();
                            return [2 /*return*/];
                        }
                        if (!refreshToken ||
                            this._tokenIsExpired(timestamp, refreshTokenLifeTime || refreshTokenExpiresIn, refreshTokenExpiresAt)) {
                            this.clearToken('IS_EXPIRED');
                            this._flushRefreshTokenQueue(null);
                            this._endRefreshToken();
                            return [2 /*return*/];
                        }
                        this._handleRefreshToken(token, isInit);
                        return [2 /*return*/];
                }
            });
        });
    };
    LocalStorageTokenSource.prototype._handleRefreshTokenTimeout = function () {
        var _this = this;
        this._timer = setTimeout(function () {
            _this._retryRefreshToken(true);
            _this._timer = undefined;
        }, TIMEOUT);
    };
    LocalStorageTokenSource.prototype._log = function (message) {
        var _a;
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        if (this.client.debug) {
            console.log.apply(console, __spreadArrays(["[LocalStorageTokenSource] " + message], optionalParams));
        }
        if (message.includes('[LOG_SKIP]')) {
            return;
        }
        this.logStack.push(message + " " + optionalParams);
        if (message.startsWith('End refreshing token')) {
            if (typeof window !== 'undefined' && ((_a = window.__GD_SLS_RUM) === null || _a === void 0 ? void 0 : _a.addLog)) {
                window.__GD_SLS_RUM.addLog.push({
                    type: 'o2c_sdk',
                    logStack: this.logStack.slice(-50)
                });
            }
            this.logStack = [];
        }
        if (this.logStack.length > 100) {
            this.logStack = [];
        }
    };
    return LocalStorageTokenSource;
}());

// @ts-nocheck
/**
 * The type of messages our frames our sending
 * @type {String}
 */
var messageType = 'application/x-postmate-v1+json';
/**
 * The maximum number of attempts to send a handshake request to the parent
 * @type {Number}
 */
var maxHandshakeRequests = 5;
/**
 * A unique message ID that is used to ensure responses are sent to the correct requests
 * @type {Number}
 */
var _messageId = 0;
/**
 * Increments and returns a message ID
 * @return {Number} A unique ID for a message
 */
var generateNewMessageId = function () { return ++_messageId; };
/**
 * Postmate logging function that enables/disables via config
 * @param  {Object} ...args Rest Arguments
 */
var log = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return Postmate.debug ? console.log.apply(console, args) : null;
}; // eslint-disable-line no-console
/**
 * Takes a URL and returns the origin
 * @param  {String} url The full URL being requested
 * @return {String}     The URLs origin
 */
var resolveOrigin = function (url) {
    var a = document.createElement('a');
    a.href = url;
    var protocol = a.protocol.length > 4 ? a.protocol : window.location.protocol;
    var host = a.host.length ? ((a.port === '80' || a.port === '443') ? a.hostname : a.host) : window.location.host;
    return a.origin || protocol + "//" + host;
};
var messageTypes = {
    handshake: 1,
    'handshake-reply': 1,
    call: 1,
    emit: 1,
    reply: 1,
    request: 1,
};
/**
 * Ensures that a message is safe to interpret
 * @param  {Object} message The postmate message being sent
 * @param  {String|Boolean} allowedOrigin The whitelisted origin or false to skip origin check
 * @return {Boolean}
 */
var sanitize = function (message, allowedOrigin) {
    if (typeof allowedOrigin === 'string' &&
        message.origin !== allowedOrigin)
        return false;
    if (!message.data)
        return false;
    if (typeof message.data === 'object' &&
        !('postmate' in message.data))
        return false;
    if (message.data.type !== messageType)
        return false;
    if (!messageTypes[message.data.postmate])
        return false;
    return true;
};
/**
 * Takes a model, and searches for a value by the property
 * @param  {Object} model     The dictionary to search against
 * @param  {String} property  A path within a dictionary (i.e. 'window.location.href')
 * @param  {Object} data      Additional information from the get request that is
 *                            passed to functions in the child model
 * @return {Promise}
 */
var resolveValue = function (model, property, data) {
    var unwrappedContext = typeof model[property] === 'function'
        ? model[property](data) : model[property];
    return Postmate.Promise.resolve(unwrappedContext);
};
/**
 * Composes an API to be used by the parent
 * @param {Object} info Information on the consumer
 */
var ParentAPI = /** @class */ (function () {
    function ParentAPI(info) {
        var _this = this;
        this.parent = info.parent;
        this.frame = info.frame;
        this.child = info.child;
        this.childOrigin = info.childOrigin;
        this.events = {};
        if (process.env.NODE_ENV !== 'production') {
            log('Parent: Registering API');
            log('Parent: Awaiting messages...');
        }
        this.listener = function (e) {
            if (!sanitize(e, _this.childOrigin))
                return false;
            /**
             * the assignments below ensures that e, data, and value are all defined
             */
            var _a = (((e || {}).data || {}).value || {}), data = _a.data, name = _a.name;
            if (e.data.postmate === 'emit') {
                if (process.env.NODE_ENV !== 'production') {
                    log("Parent: Received event emission: " + name);
                }
                if (name in _this.events) {
                    _this.events[name].forEach(function (callback) {
                        callback.call(_this, data);
                    });
                }
            }
        };
        this.parent.addEventListener('message', this.listener, false);
        if (process.env.NODE_ENV !== 'production') {
            log('Parent: Awaiting event emissions from Child');
        }
    }
    ParentAPI.prototype.get = function (property, data) {
        var _this = this;
        return new Postmate.Promise(function (resolve) {
            // Extract data from response and kill listeners
            var uid = generateNewMessageId();
            var transact = function (e) {
                var _a, _b;
                if (((_a = e.data) === null || _a === void 0 ? void 0 : _a.uid) === uid && ((_b = e.data) === null || _b === void 0 ? void 0 : _b.postmate) === 'reply') {
                    _this.parent.removeEventListener('message', transact, false);
                    resolve(e.data.value);
                }
            };
            // Prepare for response from Child...
            _this.parent.addEventListener('message', transact, false);
            // Then ask child for information
            _this.child.postMessage({
                postmate: 'request',
                type: messageType,
                property: property,
                data: data,
                uid: uid,
            }, _this.childOrigin);
        });
    };
    ParentAPI.prototype.call = function (property, data) {
        // Send information to the child
        this.child.postMessage({
            postmate: 'call',
            type: messageType,
            property: property,
            data: data,
        }, this.childOrigin);
    };
    ParentAPI.prototype.on = function (eventName, callback) {
        if (!this.events[eventName]) {
            this.events[eventName] = [];
        }
        this.events[eventName].push(callback);
    };
    ParentAPI.prototype.destroy = function () {
        if (process.env.NODE_ENV !== 'production') {
            log('Parent: Destroying Postmate instance');
        }
        window.removeEventListener('message', this.listener, false);
        this.frame.parentNode.removeChild(this.frame);
    };
    return ParentAPI;
}());
/**
 * Composes an API to be used by the child
 * @param {Object} info Information on the consumer
 */
var ChildAPI = /** @class */ (function () {
    function ChildAPI(info) {
        var _this = this;
        this.model = info.model;
        this.parent = info.parent;
        this.parentOrigin = info.parentOrigin;
        this.child = info.child;
        if (process.env.NODE_ENV !== 'production') {
            log('Child: Registering API');
            log('Child: Awaiting messages...');
        }
        this.child.addEventListener('message', function (e) {
            if (!sanitize(e, _this.parentOrigin))
                return;
            if (process.env.NODE_ENV !== 'production') {
                log('Child: Received request', e.data);
            }
            var _a = e.data, property = _a.property, uid = _a.uid, data = _a.data;
            if (e.data.postmate === 'call') {
                if (property in _this.model && typeof _this.model[property] === 'function') {
                    _this.model[property](data);
                }
                return;
            }
            // Reply to Parent
            resolveValue(_this.model, property, data)
                .then(function (value) { return e.source.postMessage({
                property: property,
                postmate: 'reply',
                type: messageType,
                uid: uid,
                value: value,
            }, e.origin); });
        });
    }
    ChildAPI.prototype.emit = function (name, data) {
        if (process.env.NODE_ENV !== 'production') {
            log("Child: Emitting Event \"" + name + "\"", data);
        }
        this.parent.postMessage({
            postmate: 'emit',
            type: messageType,
            value: {
                name: name,
                data: data,
            },
        }, this.parentOrigin);
    };
    return ChildAPI;
}());
/**
  * The entry point of the Parent.
 * @type {Class}
 */
var Postmate = /** @class */ (function () {
    /**
     * Sets options related to the Parent
     * @param {Object} object The element to inject the frame into, and the url
     * @return {Promise}
     */
    function Postmate(_a) {
        var _b = _a.container, container = _b === void 0 ? typeof container !== 'undefined' ? container : document.body : _b, // eslint-disable-line no-use-before-define
        model = _a.model, url = _a.url, name = _a.name, _c = _a.classListArray, classListArray = _c === void 0 ? [] : _c;
        var _d;
        this.parent = window;
        this.frame = document.createElement('iframe');
        this.frame.name = name || '';
        this.frame.style.border = 'none';
        this.frame.classList.add.apply(this.frame.classList, classListArray);
        container.appendChild(this.frame);
        this.child = this.frame.contentWindow || ((_d = this.frame.contentDocument) === null || _d === void 0 ? void 0 : _d.parentWindow);
        this.model = model || {};
        return this.sendHandshake(url);
    }
    /**
     * Begins the handshake strategy
     * @param  {String} url The URL to send a handshake request to
     * @return {Promise}     Promise that resolves when the handshake is complete
     */
    Postmate.prototype.sendHandshake = function (url) {
        var _this = this;
        var childOrigin = resolveOrigin(url);
        var attempt = 0;
        var responseInterval;
        return new Postmate.Promise(function (resolve, reject) {
            var reply = function (e) {
                if (!sanitize(e, childOrigin))
                    return false;
                if (e.data.postmate === 'handshake-reply') {
                    clearInterval(responseInterval);
                    if (process.env.NODE_ENV !== 'production') {
                        log('Parent: Received handshake reply from Child');
                    }
                    _this.parent.removeEventListener('message', reply, false);
                    _this.childOrigin = e.origin;
                    if (process.env.NODE_ENV !== 'production') {
                        log('Parent: Saving Child origin', _this.childOrigin);
                    }
                    return resolve(new ParentAPI(_this));
                }
            };
            _this.parent.addEventListener('message', reply, false);
            var doSend = function () {
                attempt++;
                if (process.env.NODE_ENV !== 'production') {
                    log("Parent: Sending handshake attempt " + attempt, { childOrigin: childOrigin });
                }
                _this.child.postMessage({
                    postmate: 'handshake',
                    type: messageType,
                    model: _this.model,
                }, childOrigin);
                if (attempt === maxHandshakeRequests) {
                    clearInterval(responseInterval);
                    reject(new Error('source iframe 加载失败'));
                }
            };
            var loaded = function () {
                doSend();
                responseInterval = setInterval(doSend, 500);
            };
            if (_this.frame.attachEvent) {
                _this.frame.attachEvent('onload', loaded);
            }
            else {
                _this.frame.addEventListener('load', loaded);
            }
            if (process.env.NODE_ENV !== 'production') {
                log('Parent: Loading frame', { url: url });
            }
            _this.frame.src = url;
        });
    };
    Postmate.debug = false; // eslint-disable-line no-undef
    // Internet Explorer craps itself
    Postmate.Promise = (function () {
        try {
            return window ? window.Promise : Promise;
        }
        catch (e) {
            return null;
        }
    })();
    return Postmate;
}());
/**
 * The entry point of the Child
 * @type {Class}
 */
Postmate.Model = /** @class */ (function () {
    /**
     * Initializes the child, model, parent, and responds to the Parents handshake
     * @param {Object} model Hash of values, functions, or promises
     * @return {Promise}       The Promise that resolves when the handshake has been received
     */
    function Model(model) {
        this.child = window;
        this.model = model;
        this.parent = this.child.parent;
        return this.sendHandshakeReply();
    }
    /**
     * Responds to a handshake initiated by the Parent
     * @return {Promise} Resolves an object that exposes an API for the Child
     */
    Model.prototype.sendHandshakeReply = function () {
        var _this = this;
        return new Postmate.Promise(function (resolve, reject) {
            var shake = function (e) {
                if (!e.data.postmate) {
                    return;
                }
                if (e.data.postmate === 'handshake') {
                    if (process.env.NODE_ENV !== 'production') {
                        log('Child: Received handshake from Parent');
                    }
                    _this.child.removeEventListener('message', shake, false);
                    if (process.env.NODE_ENV !== 'production') {
                        log('Child: Sending handshake reply to Parent');
                    }
                    e.source.postMessage({
                        postmate: 'handshake-reply',
                        type: messageType,
                    }, e.origin);
                    _this.parentOrigin = e.origin;
                    // Extend model with the one provided by the parent
                    var defaults_1 = e.data.model;
                    if (defaults_1) {
                        Object.keys(defaults_1).forEach(function (key) {
                            _this.model[key] = defaults_1[key];
                        });
                        if (process.env.NODE_ENV !== 'production') {
                            log('Child: Inherited and extended model from Parent');
                        }
                    }
                    if (process.env.NODE_ENV !== 'production') {
                        log('Child: Saving Parent origin', _this.parentOrigin);
                    }
                    return resolve(new ChildAPI(_this));
                }
                return reject('Handshake Reply Failed');
            };
            _this.child.addEventListener('message', shake, false);
        });
    };
    return Model;
}());

var IframeTokenSource = /** @class */ (function () {
    function IframeTokenSource(client, env) {
        var _a, _b;
        this.client = client;
        this.env = env;
        this.localTokenSource = null;
        var clientConfig = this.client.config;
        var query = {
            env: clientConfig.env,
            clientId: clientConfig.clientId,
            clientSecret: clientConfig.clientSecret,
            debug: clientConfig.debug,
            deviceId: clientConfig.deviceId || getUserDeviceId(),
            bizCode: clientConfig.bizCode,
            tokenEndpoint: clientConfig.tokenEndpoint,
            tokenMethod: clientConfig.tokenMethod,
            name: (_a = clientConfig.name) !== null && _a !== void 0 ? _a : 'ums',
            tokenKey: clientConfig.scopeToken ? clientConfig.clientId + "." + TOKEN_KEY : clientConfig.tokenKey,
            channelId: clientConfig.channelId
        };
        clientConfig.channelId && (query.channelId = clientConfig.channelId);
        clientConfig.noEncryption && (query.noEncryption = true);
        clientConfig.domain && (query.domain = clientConfig.domain);
        clientConfig.samesite && (query.samesite = clientConfig.samesite);
        if (clientConfig.qiyeSsoURI) {
            query.qiyeSsoURI = clientConfig.qiyeSsoURI;
        }
        this.iframeName = query.name + "-source";
        var iframeTokenSourceURL = (_b = clientConfig.iframeTokenSourceURL) !== null && _b !== void 0 ? _b : envConfigMap[this.env].iframeTokenSourceURL;
        this.iframeUrl = iframeTokenSourceURL + qs.stringify(query, { addQueryPrefix: true });
        this._handshake = new Postmate({
            url: this.iframeUrl,
            name: this.iframeName,
            // @ts-ignore
            classListArray: [this.iframeName]
        });
        var style = document.createElement('style');
        style.setAttribute('type', 'text/css');
        style.textContent = "." + this.iframeName + " { display: none; }";
        document.head.appendChild(style);
        this._iframeStyle = style;
        this.iframeLoadTimeout = false;
    }
    IframeTokenSource.prototype.getLocalTokenSource = function () {
        if (!this.localTokenSource) {
            this.localTokenSource = new LocalStorageTokenSource(this.client);
        }
        return this.localTokenSource;
    };
    IframeTokenSource.prototype.getHandshake = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.iframeLoadTimeout) {
                            this.iframeLoadTimeout = false;
                            this._handshake = new Postmate({
                                url: this.iframeUrl,
                                name: this.iframeName,
                                // @ts-ignore
                                classListArray: [this.iframeName]
                            });
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._handshake];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_1 = _a.sent();
                        console.log(error_1);
                        this.iframeLoadTimeout = true;
                        return [2 /*return*/, { get: function (fn, data) {
                                    var _a, _b;
                                    return (_b = (_a = _this.getLocalTokenSource()) === null || _a === void 0 ? void 0 : _a[fn]) === null || _b === void 0 ? void 0 : _b.call(_a, data);
                                } }];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    IframeTokenSource.prototype.getAccessToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var child, accessToken;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getHandshake()];
                    case 1:
                        child = _a.sent();
                        return [4 /*yield*/, child.get('getAccessToken')];
                    case 2:
                        accessToken = _a.sent();
                        this._log('Access token:', accessToken);
                        return [2 /*return*/, accessToken];
                }
            });
        });
    };
    IframeTokenSource.prototype.getToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var child;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getHandshake()];
                    case 1:
                        child = _a.sent();
                        // @ts-ignore
                        return [2 /*return*/, child.get('getToken')];
                }
            });
        });
    };
    IframeTokenSource.prototype.setToken = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            var child;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getHandshake()];
                    case 1:
                        child = _a.sent();
                        // @ts-ignore
                        return [4 /*yield*/, child.get('setToken', token)];
                    case 2:
                        // @ts-ignore
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    IframeTokenSource.prototype.clearToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var child;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getHandshake()];
                    case 1:
                        child = _a.sent();
                        // @ts-ignore
                        return [2 /*return*/, child.get('clearToken')];
                }
            });
        });
    };
    IframeTokenSource.prototype.login = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            var child;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getHandshake()];
                    case 1:
                        child = _a.sent();
                        // @ts-ignore
                        return [2 /*return*/, child.get('login', token)];
                }
            });
        });
    };
    IframeTokenSource.prototype.setOrgId = function (org_id) {
        return __awaiter(this, void 0, void 0, function () {
            var child;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getHandshake()];
                    case 1:
                        child = _a.sent();
                        // @ts-ignore
                        return [2 /*return*/, child.get('setOrgId', org_id)];
                }
            });
        });
    };
    IframeTokenSource.prototype.getOrgId = function () {
        return __awaiter(this, void 0, void 0, function () {
            var child;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getHandshake()];
                    case 1:
                        child = _a.sent();
                        // @ts-ignore
                        return [2 /*return*/, child.get('getOrgId')];
                }
            });
        });
    };
    IframeTokenSource.prototype.setExtraData = function (key, data) {
        return __awaiter(this, void 0, void 0, function () {
            var child;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getHandshake()];
                    case 1:
                        child = _a.sent();
                        // @ts-ignore
                        return [2 /*return*/, child.get('setExtraData', { key: key, data: data })];
                }
            });
        });
    };
    IframeTokenSource.prototype.getExtraData = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            var child;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getHandshake()];
                    case 1:
                        child = _a.sent();
                        // @ts-ignore
                        return [2 /*return*/, child.get('getExtraData', key)];
                }
            });
        });
    };
    IframeTokenSource.prototype.mergedAccountCheck = function () {
        return __awaiter(this, void 0, void 0, function () {
            var child;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getHandshake()];
                    case 1:
                        child = _a.sent();
                        // @ts-ignore
                        return [2 /*return*/, child.get('mergedAccountCheck')];
                }
            });
        });
    };
    IframeTokenSource.prototype._log = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        if (this.client.debug) {
            console.log.apply(console, __spreadArrays(["[IframeTokenSource] " + message], optionalParams));
        }
    };
    return IframeTokenSource;
}());

var EmptyTokenSource = /** @class */ (function () {
    function EmptyTokenSource() {
    }
    EmptyTokenSource.prototype.setup = function () { };
    EmptyTokenSource.prototype.teardown = function () { };
    EmptyTokenSource.prototype.getAccessToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, undefined];
            });
        });
    };
    EmptyTokenSource.prototype.getToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, null];
            });
        });
    };
    EmptyTokenSource.prototype.setToken = function (_) {
        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); });
    };
    EmptyTokenSource.prototype.getOrgId = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, ''];
            });
        });
    };
    EmptyTokenSource.prototype.setOrgId = function (_) {
        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); });
    };
    EmptyTokenSource.prototype.setExtraData = function (key, data) {
        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); });
    };
    EmptyTokenSource.prototype.getExtraData = function (key) {
        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); });
    };
    EmptyTokenSource.prototype.clearToken = function () {
        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); });
    };
    return EmptyTokenSource;
}());

var AppTokenSource = /** @class */ (function () {
    function AppTokenSource(client, config) {
        this.client = client;
        this.refreshQueue = [];
        var _a = config.env, env = _a === void 0 ? Env.Prod : _a, tokenSourceType = config.tokenSourceType, gnbInstance = config.gnbInstance;
        this.config = config;
        this.getGNBInstance();
        if (tokenSourceType === TokenSourceType.LocalStorage || tokenSourceType === TokenSourceType.LocalStorageForce) {
            this._tokenSource = new LocalStorageTokenSource(client);
        }
        else if (tokenSourceType === TokenSourceType.Iframe || tokenSourceType === TokenSourceType.IframeForce) {
            this._tokenSource = new IframeTokenSource(client, env);
        }
        else if (config.tokenSource) {
            this._tokenSource = config.tokenSource;
        }
        else {
            this._tokenSource = new IframeTokenSource(client, env);
        }
    }
    AppTokenSource.prototype.getGNBInstance = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        return __awaiter(this, void 0, void 0, function () {
            var GNB;
            return __generator(this, function (_r) {
                switch (_r.label) {
                    case 0:
                        console.log('AppTokenSource:::v2 this.config?.gnbInstance ==> ', (_a = this.config) === null || _a === void 0 ? void 0 : _a.gnbInstance);
                        console.log('AppTokenSource:::v2 window.GD_GNB_INSTANCE ==> ', window.GD_GNB_INSTANCE);
                        console.log('AppTokenSource:::v2 window.GD_GNB_INSTANCE.GNB ==> ', (_b = window.GD_GNB_INSTANCE) === null || _b === void 0 ? void 0 : _b.GNB);
                        if (!!(((_c = this.config) === null || _c === void 0 ? void 0 : _c.gnbInstance) || window.GD_GNB_INSTANCE)) return [3 /*break*/, 2];
                        return [4 /*yield*/, import('@gaoding/gaoding-native-bridge')];
                    case 1:
                        GNB = (_r.sent()).GNB;
                        console.log('AppTokenSource:::v2 import(@gaoding/gaoding-native-bridge) ==> ', typeof GNB);
                        return [2 /*return*/, GNB];
                    case 2: return [2 /*return*/, {
                            organization: ((_e = (_d = this.config) === null || _d === void 0 ? void 0 : _d.gnbInstance) === null || _e === void 0 ? void 0 : _e.organization) || ((_g = (_f = window.GD_GNB_INSTANCE) === null || _f === void 0 ? void 0 : _f.GNB) === null || _g === void 0 ? void 0 : _g.organization),
                            account: ((_j = (_h = this.config) === null || _h === void 0 ? void 0 : _h.gnbInstance) === null || _j === void 0 ? void 0 : _j.account) || ((_l = (_k = window.GD_GNB_INSTANCE) === null || _k === void 0 ? void 0 : _k.GNB) === null || _l === void 0 ? void 0 : _l.account),
                            network: ((_o = (_m = this.config) === null || _m === void 0 ? void 0 : _m.gnbInstance) === null || _o === void 0 ? void 0 : _o.network) || ((_q = (_p = window.GD_GNB_INSTANCE) === null || _p === void 0 ? void 0 : _p.GNB) === null || _q === void 0 ? void 0 : _q.network),
                        }];
                }
            });
        });
    };
    AppTokenSource.prototype.getAccessToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var access_token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getToken()];
                    case 1:
                        access_token = ((_a.sent()) || {}).access_token;
                        console.log('AppTokenSource:::v2 getAccessToken ==> ', access_token);
                        return [2 /*return*/, access_token || this._tokenSource.getAccessToken()];
                }
            });
        });
    };
    AppTokenSource.prototype.getToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var search, umsToken, headers;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (typeof window && window.location.search.includes('token_data')) {
                            search = qs.parse(window.location.search, { ignoreQueryPrefix: true });
                            console.log('AppTokenSource:::v2 get accessToken from window.location.search token_data ==>', search['token_data']);
                            if (search && search['token_data']) {
                                return [2 /*return*/, JSON.parse(decodeURIComponent(search['token_data']))];
                            }
                        }
                        return [4 /*yield*/, this.getGNBToken()];
                    case 1:
                        umsToken = _a.sent();
                        console.log('AppTokenSource:::v2 get accessToken from GNB.account.getUMSInfo() ==>', umsToken);
                        if (umsToken) {
                            return [2 /*return*/, umsToken];
                        }
                        return [4 /*yield*/, getHttpHeadsAdapter()];
                    case 2:
                        headers = _a.sent();
                        console.log('AppTokenSource:::v2 get accessToken from bridge.call("getHttpHeads") ==>', headers);
                        if (headers) {
                            if (typeof headers.token === 'string') {
                                return [2 /*return*/, {
                                        access_token: headers.token,
                                        access_token_expires_at: '',
                                        access_token_life_time: 0,
                                        refresh_token: '',
                                        refresh_token_expires_at: '',
                                        refresh_token_life_time: 0,
                                        timestamp: Date.now(),
                                    }];
                            }
                            if (headers.token && headers.token.access_token) {
                                return [2 /*return*/, headers.token];
                            }
                        }
                        return [2 /*return*/, this._tokenSource.getToken()];
                }
            });
        });
    };
    AppTokenSource.prototype.setToken = function (_) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this._tokenSource.setToken(_)];
            });
        });
    };
    /**
     * https://docs.gdm.gaoding.com/gnb/organization.html#fetchorganizationinfo
     * @returns orgid string
     */
    AppTokenSource.prototype.getOrgId = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var GNBInstance, res, orgId, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getGNBInstance()];
                    case 1:
                        GNBInstance = _b.sent();
                        return [4 /*yield*/, GNBInstance.organization.fetchOrganizationInfo()];
                    case 2:
                        res = _b.sent();
                        orgId = ((_a = res.tenantInfo.company) === null || _a === void 0 ? void 0 : _a.id) || '';
                        console.log('AppTokenSource:::v2 get orgid ==>', orgId);
                        return [2 /*return*/, orgId];
                    case 3:
                        error_1 = _b.sent();
                        console.log('AppTokenSource:::v2 orgid failed to fetch ==>', error_1);
                        return [2 /*return*/, this._tokenSource.getOrgId()];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AppTokenSource.prototype.setOrgId = function (_) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this._tokenSource.setOrgId(_)];
            });
        });
    };
    AppTokenSource.prototype.clearToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this._tokenSource.clearToken()];
            });
        });
    };
    AppTokenSource.prototype.setExtraData = function (key, data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this._tokenSource.setExtraData(key, data)];
            });
        });
    };
    AppTokenSource.prototype.getExtraData = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this._tokenSource.getExtraData(key)];
            });
        });
    };
    AppTokenSource.prototype.getGNBToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var GNBInstance, umsToken, error_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getGNBInstance()];
                    case 1:
                        GNBInstance = _a.sent();
                        return [4 /*yield*/, GNBInstance.account.getUMSInfo()];
                    case 2:
                        umsToken = ((_a.sent()) || {}).umsToken;
                        if (!umsToken) {
                            return [2 /*return*/];
                        }
                        if (!this.tokenIsExpired(umsToken)) {
                            return [2 /*return*/, umsToken];
                        }
                        return [2 /*return*/, new Promise(function (resolve) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            this.refreshQueue.push({ resolve: resolve });
                                            if (this.refreshQueue.length > 1) {
                                                return [2 /*return*/];
                                            }
                                            return [4 /*yield*/, this.refreshToken()];
                                        case 1:
                                            _a.sent();
                                            this.refreshQueueExecute();
                                            return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 3:
                        error_2 = _a.sent();
                        console.log('AppTokenSource:::v2 get accessToken from GNB.account.getGNBToken() ==>', error_2);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AppTokenSource.prototype.refreshToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var GNBInstance, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getGNBInstance()];
                    case 1:
                        GNBInstance = _a.sent();
                        return [4 /*yield*/, GNBInstance.network.request({
                                method: 'GET',
                                path: '/api/users/bindings/',
                                host: 'ums',
                            })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _a.sent();
                        console.log('AppTokenSource:::v2 refreshToken error ==>', error_3);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AppTokenSource.prototype.refreshQueueExecute = function () {
        return __awaiter(this, void 0, void 0, function () {
            var GNBInstance, umsToken, i, task;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getGNBInstance()];
                    case 1:
                        GNBInstance = _a.sent();
                        return [4 /*yield*/, GNBInstance.account.getUMSInfo()];
                    case 2:
                        umsToken = ((_a.sent()) || {}).umsToken;
                        for (i = 0; i < this.refreshQueue.length; i++) {
                            task = this.refreshQueue[i];
                            task.resolve(umsToken);
                        }
                        this.refreshQueue = [];
                        return [2 /*return*/];
                }
            });
        });
    };
    AppTokenSource.prototype.tokenIsExpired = function (token) {
        var access_token_expires_at = token.access_token_expires_at;
        if (access_token_expires_at) {
            return Date.parse(access_token_expires_at) < Date.now() + TIME_FACTOR;
        }
        return true;
    };
    return AppTokenSource;
}());

var HUABAN_ACCESS_TOKEN_KEY = 'gd_huaban_client_access_token';
var HuabanTokenSource = /** @class */ (function () {
    function HuabanTokenSource(client) {
        this.client = client;
        this.tokenInfo = null;
        this.refreshQueue = [];
        this.isRefreshToken = false;
        this.domain = host$1;
        var _a = client.config, env = _a.env, webRequireURI = _a.webRequireURI;
        this._orgId = ORG_ID_KEY + "." + env;
        this.uidKey = env === 'prod' ? 'uid' : "uid." + env;
        this.webRequireURI = webRequireURI || '';
    }
    HuabanTokenSource.prototype.getAccessToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var access_token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getToken()];
                    case 1:
                        access_token = ((_a.sent()) || {}).access_token;
                        return [2 /*return*/, access_token];
                }
            });
        });
    };
    HuabanTokenSource.prototype.getToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getHuabanToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.tokenInfo];
                }
            });
        });
    };
    HuabanTokenSource.prototype.setToken = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.tokenInfo = token;
                return [2 /*return*/];
            });
        });
    };
    HuabanTokenSource.prototype.setOrgId = function (org_id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                localStorage.setItem(this._orgId, org_id);
                Cookies.set(this._orgId, org_id, { expires: 15, domain: this.domain });
                return [2 /*return*/];
            });
        });
    };
    HuabanTokenSource.prototype.getOrgId = function () {
        return __awaiter(this, void 0, void 0, function () {
            var ckOrgId, lSorgId;
            return __generator(this, function (_a) {
                ckOrgId = Cookies.get(this._orgId);
                lSorgId = localStorage.getItem(this._orgId);
                if (ckOrgId) {
                    localStorage.setItem(this._orgId, ckOrgId);
                }
                if (lSorgId && !ckOrgId) {
                    Cookies.set(this._orgId, lSorgId, { expires: 15, domain: this.domain });
                }
                return [2 /*return*/, ckOrgId || lSorgId || ''];
            });
        });
    };
    HuabanTokenSource.prototype.setExtraData = function (key, data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                localStorage.setItem("" + EXTRA_DATA + key, JSON.stringify(data));
                return [2 /*return*/];
            });
        });
    };
    HuabanTokenSource.prototype.getExtraData = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            var extraData, parsed;
            return __generator(this, function (_a) {
                extraData = localStorage.getItem("" + EXTRA_DATA + key);
                if (extraData) {
                    try {
                        parsed = JSON.parse(extraData);
                        return [2 /*return*/, parsed];
                        /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
                    }
                    catch (error) {
                        // ignore error
                        return [2 /*return*/, null];
                    }
                }
                return [2 /*return*/, null];
            });
        });
    };
    HuabanTokenSource.prototype.clearToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.tokenInfo = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, http.get(this.webRequireURI + "/logout")];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    HuabanTokenSource.prototype.mockToken = function () {
        var lifeTime = 365 * 24 * 60 * 60 * 1000;
        var now = new Date(Date.now() + lifeTime);
        var isoString = now.toISOString();
        this.tokenInfo = {
            access_token: HUABAN_ACCESS_TOKEN_KEY,
            access_token_expires_at: isoString,
            access_token_life_time: lifeTime,
            refresh_token: HUABAN_ACCESS_TOKEN_KEY,
            refresh_token_expires_at: isoString,
            refresh_token_life_time: lifeTime,
            timestamp: Date.now()
        };
    };
    HuabanTokenSource.prototype.getHuabanToken = function () {
        var _this = this;
        try {
            var uidVal = Cookies.get(this.uidKey);
            if (!uidVal) {
                this.tokenInfo = null;
                return;
            }
            if (this.tokenInfo) {
                return this.tokenInfo;
            }
            return new Promise(function (resolve) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.refreshQueue.push({ resolve: resolve });
                            if (this.refreshQueue.length > 1) {
                                return [2 /*return*/];
                            }
                            return [4 /*yield*/, this.refreshToken()];
                        case 1:
                            _a.sent();
                            this.refreshQueueExecute();
                            return [2 /*return*/];
                    }
                });
            }); });
        }
        catch (error) {
            console.log('AppTokenSource::: get accessToken from GNB.account.getGNBToken() ==>', error);
        }
    };
    HuabanTokenSource.prototype.refreshToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        if (this.isRefreshToken) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, http.head(this.webRequireURI + "/me")];
                    case 1:
                        _a.sent();
                        this.isRefreshToken = true;
                        this.mockToken();
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        if (error_2.status) {
                            this.isRefreshToken = true;
                        }
                        this.tokenInfo = null;
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    HuabanTokenSource.prototype.refreshQueueExecute = function () {
        return __awaiter(this, void 0, void 0, function () {
            var i, task;
            return __generator(this, function (_a) {
                for (i = 0; i < this.refreshQueue.length; i++) {
                    task = this.refreshQueue[i];
                    task.resolve(this.tokenInfo);
                }
                this.refreshQueue = [];
                return [2 /*return*/];
            });
        });
    };
    return HuabanTokenSource;
}());

var HuabanTokenSourceV2 = /** @class */ (function () {
    function HuabanTokenSourceV2(client) {
        this.client = client;
        this.tokenInfo = null;
        this.refreshQueue = [];
        this.isRefreshToken = false;
        var _a = client.config, env = _a.env, webRequireURI = _a.webRequireURI;
        this.uidKey = env === 'prod' ? 'uid' : "uid." + env;
        this.webRequireURI = webRequireURI || '';
        this._tokenSource = new LocalStorageTokenSource(client);
    }
    HuabanTokenSourceV2.prototype.getAccessToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var access_token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getToken()];
                    case 1:
                        access_token = ((_a.sent()) || {}).access_token;
                        return [2 /*return*/, access_token];
                }
            });
        });
    };
    HuabanTokenSourceV2.prototype.getToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getHuabanToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._tokenSource.getToken()];
                }
            });
        });
    };
    HuabanTokenSourceV2.prototype.setToken = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._tokenSource.setToken(token)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    HuabanTokenSourceV2.prototype.setOrgId = function (org_id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._tokenSource.setOrgId(org_id)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    HuabanTokenSourceV2.prototype.getOrgId = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._tokenSource.getOrgId()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    HuabanTokenSourceV2.prototype.setExtraData = function (key, data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._tokenSource.setExtraData(key, data)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    HuabanTokenSourceV2.prototype.getExtraData = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._tokenSource.getExtraData(key)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    HuabanTokenSourceV2.prototype.clearToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._tokenSource.clearToken()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, http.get(this.webRequireURI + "/logout")];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    HuabanTokenSourceV2.prototype.getHuabanToken = function () {
        var _this = this;
        try {
            var uidVal = Cookies.get(this.uidKey);
            if (!uidVal) {
                this.tokenInfo = null;
                return;
            }
            if (this.tokenInfo) {
                return this.tokenInfo;
            }
            return new Promise(function (resolve) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.refreshQueue.push({ resolve: resolve });
                            if (this.refreshQueue.length > 1) {
                                return [2 /*return*/];
                            }
                            return [4 /*yield*/, this.refreshToken()];
                        case 1:
                            _a.sent();
                            this.refreshQueueExecute();
                            return [2 /*return*/];
                    }
                });
            }); });
        }
        catch (error) {
            console.log('HuabanTokenSourceV2::: getHuabanToken error ==>', error);
        }
    };
    HuabanTokenSourceV2.prototype.refreshToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        if (this.isRefreshToken) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, http.head(this.webRequireURI + "/me")];
                    case 1:
                        _a.sent();
                        this.isRefreshToken = true;
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        if (error_2.status) {
                            this.isRefreshToken = true;
                        }
                        this.tokenInfo = null;
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    HuabanTokenSourceV2.prototype.refreshQueueExecute = function () {
        return __awaiter(this, void 0, void 0, function () {
            var i, task;
            return __generator(this, function (_a) {
                for (i = 0; i < this.refreshQueue.length; i++) {
                    task = this.refreshQueue[i];
                    task.resolve(this.tokenInfo);
                }
                this.refreshQueue = [];
                return [2 /*return*/];
            });
        });
    };
    return HuabanTokenSourceV2;
}());

var MemoryTokenSource = /** @class */ (function () {
    function MemoryTokenSource(client) {
        this.client = client;
        this.token = null;
        this.orgId = '';
        this.extraData = {};
    }
    MemoryTokenSource.prototype.getAccessToken = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, (_a = this.token) === null || _a === void 0 ? void 0 : _a.access_token];
            });
        });
    };
    MemoryTokenSource.prototype.getToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.token];
            });
        });
    };
    MemoryTokenSource.prototype.setToken = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.token = token;
                return [2 /*return*/];
            });
        });
    };
    MemoryTokenSource.prototype.getOrgId = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.orgId];
            });
        });
    };
    MemoryTokenSource.prototype.setOrgId = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.orgId = id;
                return [2 /*return*/];
            });
        });
    };
    MemoryTokenSource.prototype.setExtraData = function (key, data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.extraData[key] = data;
                return [2 /*return*/];
            });
        });
    };
    MemoryTokenSource.prototype.getExtraData = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.extraData[key];
                return [2 /*return*/];
            });
        });
    };
    MemoryTokenSource.prototype.clearToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.token = null;
                return [2 /*return*/];
            });
        });
    };
    return MemoryTokenSource;
}());

var PASSWORD = 'gaodingcom';
// 加密函数
function encrypt(text, password) {
    return AES.encrypt(text, password, {
        mode: ECB,
    }).toString();
}
var dataEncryption = (function (obj) {
    var textToEncrypt = JSON.stringify(obj);
    return encrypt(textToEncrypt, PASSWORD);
});

var windowOpen = (function (options) {
    var _a = Object.assign({ width: 886, height: 500 }, options), url = _a.url, width = _a.width, height = _a.height, target = _a.target;
    // 获取当前窗口的尺寸（适用于分屏情况）
    var screenWidth = window.innerWidth;
    var screenHeight = window.innerHeight;
    // 获取当前窗口的左上角位置（适用于多屏环境）
    var screenLeft = window.screenX || window.screenLeft;
    var screenTop = window.screenY || window.screenTop;
    // 计算窗口居中的位置
    var left = screenLeft + (screenWidth - width) / 2;
    var top = screenTop + (screenHeight - height) / 2;
    var style = "status=no,resizable=no,scrollbars=yes,personalbar=no,directories=no,location=no,toolbar=no,menubar=no,width=" + width + ",height=" + height + ",left=" + left + ",top=" + top;
    if (target === 'popup') {
        return window.open(url, '', style);
    }
    return window.open(url, '_blank');
});

var AuthManager = /** @class */ (function () {
    function AuthManager(client, options) {
        var _this = this;
        this.client = client;
        this.options = options;
        this.windowProxy = null;
        this.windowProxyCloseFlag = null;
        this.closeCheckTimer = null;
        this.successCallbacks = [];
        this.failedCallbacks = [];
        this.registerCallbacks = [];
        this.cancelCallbacks = [];
        this.handleMessage = function (event) { return __awaiter(_this, void 0, void 0, function () {
            var _a, action, resData, _b, token;
            var _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = event.data || { action: '', resData: null }, action = _a.action, resData = _a.resData;
                        // 验证消息来源
                        if (!(action === null || action === void 0 ? void 0 : action.startsWith('ums.auth'))) {
                            return [2 /*return*/];
                        }
                        _b = action;
                        switch (_b) {
                            case 'ums.auth.origin.check': return [3 /*break*/, 1];
                            case 'ums.auth.success': return [3 /*break*/, 2];
                            case 'ums.auth.failed': return [3 /*break*/, 4];
                            case 'ums.auth.register': return [3 /*break*/, 5];
                        }
                        return [3 /*break*/, 6];
                    case 1:
                        (_c = this.windowProxy) === null || _c === void 0 ? void 0 : _c.postMessage({ action: 'ums.auth.origin.handshake' }, event.origin);
                        return [2 /*return*/];
                    case 2:
                        this.windowProxyCloseFlag = 'auth.success';
                        return [4 /*yield*/, this.client.getToken()];
                    case 3:
                        token = _d.sent();
                        this.triggerSuccess({ token: token });
                        this.destroy();
                        return [2 /*return*/];
                    case 4:
                        this.triggerFailed(resData);
                        return [2 /*return*/];
                    case 5:
                        this.triggerRegister(resData);
                        return [2 /*return*/];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
    }
    AuthManager.prototype.getOpenUrl = function () {
        var _a = this.options || {}, projectName = _a.projectName, _b = _a.redirectUrl, redirectUrl = _b === void 0 ? window.location.href : _b, authUrl = _a.authUrl, target = _a.target;
        var _isMobile = isMobile();
        var params = {
            app_id: projectName,
            login_type: _isMobile ? 'redirect' : target || 'blank',
            prompt: 'null',
            redirect_url: redirectUrl,
        };
        return (authUrl || envConfigMap[this.client.config.env || 'prod'].umsAuthURI) + "?" + qs.stringify(params);
    };
    AuthManager.prototype.initWindow = function () {
        var _a;
        var _b = this.options || {}, width = _b.width, height = _b.height, target = _b.target;
        var _isMobile = isMobile();
        var openUrl = this.getOpenUrl();
        if (_isMobile) {
            window.location.replace(openUrl);
            return;
        }
        // 自动关闭前一个实例
        (_a = AuthManager.activeInstance) === null || _a === void 0 ? void 0 : _a.destroy();
        AuthManager.activeInstance = this;
        this.setupListeners();
        this.windowProxy = windowOpen({
            url: openUrl,
            target: target,
            width: width || 540,
            height: height || 540,
        });
        this.startCloseChecker();
        return this;
    };
    AuthManager.prototype.startCloseChecker = function () {
        var _this = this;
        var _a;
        if ((_a = this.windowProxy) === null || _a === void 0 ? void 0 : _a.closed) {
            if (!this.windowProxyCloseFlag) {
                this.triggerCancel();
            }
            this.destroy();
            return;
        }
        this.closeCheckTimer = setTimeout(function () { return _this.startCloseChecker(); }, 100);
    };
    AuthManager.prototype.triggerSuccess = function (data) {
        this.successCallbacks.forEach(function (cb) { return cb(data); });
    };
    AuthManager.prototype.triggerFailed = function (data) {
        this.failedCallbacks.forEach(function (cb) { return cb(data); });
    };
    AuthManager.prototype.triggerRegister = function (data) {
        this.registerCallbacks.forEach(function (cb) { return cb(data); });
    };
    AuthManager.prototype.triggerCancel = function () {
        this.cancelCallbacks.forEach(function (cb) { return cb(); });
    };
    AuthManager.prototype.setupListeners = function () {
        window.addEventListener('message', this.handleMessage, false);
    };
    // 公开方法
    AuthManager.prototype.onSuccess = function (callback) {
        this.successCallbacks.push(callback);
        return this;
    };
    AuthManager.prototype.onFailed = function (callback) {
        this.failedCallbacks.push(callback);
        return this;
    };
    AuthManager.prototype.onRegister = function (callback) {
        this.registerCallbacks.push(callback);
        return this;
    };
    AuthManager.prototype.onCancel = function (callback) {
        this.cancelCallbacks.push(callback);
        return this;
    };
    AuthManager.prototype.destroy = function () {
        var _a;
        // 清除静态引用
        if (AuthManager.activeInstance === this) {
            AuthManager.activeInstance = null;
        }
        window.removeEventListener('message', this.handleMessage);
        (_a = this.windowProxy) === null || _a === void 0 ? void 0 : _a.close();
        // 清空回调防止内存泄漏
        this.successCallbacks = [];
        this.failedCallbacks = [];
        this.registerCallbacks = [];
        this.cancelCallbacks = [];
        if (this.closeCheckTimer) {
            clearTimeout(this.closeCheckTimer);
        }
    };
    AuthManager.activeInstance = null;
    return AuthManager;
}());

var AuthManager$1 = /** @class */ (function () {
    function AuthManager(client, options) {
        var _this = this;
        var _a;
        this.client = client;
        this.options = options;
        this.windowProxy = null;
        this.closeCheckTimer = null;
        this.successCallbacks = [];
        this.failedCallbacks = [];
        this.cancelCallbacks = [];
        this.handleMessage = function (event) {
            var _a;
            var _b = event.data || { action: '', token: null, resData: null }, action = _b.action, token = _b.token, resData = _b.resData;
            // 验证消息来源
            if (!action.startsWith('ums.auth')) {
                return;
            }
            switch (action) {
                case 'ums.auth.origin.check':
                    (_a = _this.windowProxy) === null || _a === void 0 ? void 0 : _a.postMessage({ action: 'ums.auth.origin.handshake' }, event.origin);
                    return;
                case 'ums.auth.success':
                    _this.client.login(token);
                    _this.triggerSuccess(resData);
                    break;
                case 'ums.auth.failed':
                    _this.triggerFailed(resData);
                    break;
                case 'ums.auth.cancel':
                    _this.triggerCancel();
                    break;
            }
            _this.destroy();
        };
        // 自动关闭前一个实例
        (_a = AuthManager.activeInstance) === null || _a === void 0 ? void 0 : _a.destroy();
        AuthManager.activeInstance = this;
        this.setupListeners();
        this.initWindow();
    }
    AuthManager.prototype.initWindow = function () {
        var _a = this.options, projectName = _a.projectName, _b = _a.callbackUrl, callbackUrl = _b === void 0 ? window.location.href : _b, _c = _a.deviceId, deviceId = _c === void 0 ? getUserDeviceId() || '' : _c, authUrl = _a.authUrl, width = _a.width, height = _a.height;
        var openUrl = (authUrl || envConfigMap[this.client.config.env || 'prod'].umsAuthURIOld) + "?appid=" + projectName + "&callback_url=" + encodeURIComponent(callbackUrl) + "&device_id=" + deviceId;
        if (isMobile()) {
            window.location.replace(openUrl + "&authorization_type=code");
            return;
        }
        this.windowProxy = windowOpen({
            url: openUrl,
            target: 'popup',
            width: width || 540,
            height: height || 540,
        });
        this.startCloseChecker();
    };
    AuthManager.prototype.startCloseChecker = function () {
        var _this = this;
        var _a;
        if ((_a = this.windowProxy) === null || _a === void 0 ? void 0 : _a.closed) {
            this.destroy();
            return;
        }
        this.closeCheckTimer = setTimeout(function () { return _this.startCloseChecker(); }, 100);
    };
    AuthManager.prototype.triggerSuccess = function (data) {
        this.successCallbacks.forEach(function (cb) { return cb(data); });
    };
    AuthManager.prototype.triggerFailed = function (data) {
        this.failedCallbacks.forEach(function (cb) { return cb(data); });
    };
    AuthManager.prototype.triggerCancel = function () {
        this.cancelCallbacks.forEach(function (cb) { return cb(); });
    };
    AuthManager.prototype.setupListeners = function () {
        window.addEventListener('message', this.handleMessage, false);
    };
    // 公开方法
    AuthManager.prototype.onSuccess = function (callback) {
        this.successCallbacks.push(callback);
        return this;
    };
    AuthManager.prototype.onFailed = function (callback) {
        this.failedCallbacks.push(callback);
        return this;
    };
    AuthManager.prototype.onCancel = function (callback) {
        this.cancelCallbacks.push(callback);
        return this;
    };
    AuthManager.prototype.destroy = function () {
        var _a;
        // 清除静态引用
        if (AuthManager.activeInstance === this) {
            AuthManager.activeInstance = null;
        }
        window.removeEventListener('message', this.handleMessage);
        (_a = this.windowProxy) === null || _a === void 0 ? void 0 : _a.close();
        // 清空回调防止内存泄漏
        this.successCallbacks = [];
        this.failedCallbacks = [];
        this.cancelCallbacks = [];
        if (this.closeCheckTimer) {
            clearTimeout(this.closeCheckTimer);
        }
    };
    AuthManager.activeInstance = null;
    return AuthManager;
}());

var windowRedirect = (function (target) {
    var _isMobile = isMobile();
    var newWindow = null;
    if (!_isMobile && target === 'blank') {
        newWindow = window.open('about:blank', '_blank');
    }
    return function (url) {
        if (!target || target === 'null') {
            return url;
        }
        if (isMobile()) {
            window.location.replace(url);
            return;
        }
        if (newWindow) {
            newWindow.location.href = url;
            return;
        }
        window.location.href = url;
    };
});

var OAuth2Client = /** @class */ (function () {
    function OAuth2Client(config) {
        var _a, _b, _c;
        this.config = config;
        this.isNoEncryption = false;
        this._schema = 'Bearer';
        this._defaultHeadersConfig = {
            'X-Biz-Code': '1',
            'X-Device-Id': (_a = getUserDeviceId()) !== null && _a !== void 0 ? _a : '',
            'X-Guest-Token': (_b = getUserDeviceId()) !== null && _b !== void 0 ? _b : ''
        };
        /**
         * https://doc.huanleguang.com/pages/viewpage.action?pageId=328790116
         * @param checkOptions
         * @param error
         * @returns
         */
        this.checkTokenStatusFlag = false;
        /**
         * 用户注销提示弹窗
         */
        this.checkLogoutStatusFlag = false;
        if (inBrowser && window.__OAUTH2_CLIENT__) {
            return window.__OAUTH2_CLIENT__;
        }
        if (OAuth2Client.instance) {
            return OAuth2Client.instance;
        }
        var _d = config.env, env = _d === void 0 ? Env.Prod : _d, _e = config.debug, debug = _e === void 0 ? false : _e;
        this.debug = debug || (inBrowser && location.href.includes('__a2c_log=1'));
        this.config.portal = this.config.portal || (inBrowser && location.href.includes('huaban.com')) ? 'huaban' : 'gaoding';
        this.config.endpoint = this.config.endpoint || (isMobile() ? ENDPOINT.H5 : ENDPOINT.WEB);
        if (!["dev", "fat", "stage", "prod"].includes(env)) {
            throw new Error('config env should be one of ["dev", "stage", "prod", "fat"]');
        }
        if (!this.hasConfig(config, 'clientId')) {
            config.clientId = envConfigMap[env].clientId;
        }
        if (!this.hasConfig(config, 'clientSecret')) {
            config.clientSecret = envConfigMap[env].clientSecret;
        }
        if (!this.hasConfig(config, 'tokenEndpoint')) {
            config.tokenEndpoint = envConfigMap[env].tokenEndpoint;
        }
        if (!this.hasConfig(config, 'tokenMethod')) {
            config.tokenMethod = 'post';
        }
        if (!this.hasConfig(config, 'authorizationEndpoint')) {
            config.authorizationEndpoint = envConfigMap[env].authorizationEndpoint;
        }
        if (!this.hasConfig(config, 'redirectURI')) {
            config.redirectURI = envConfigMap[env].redirectURI;
        }
        if (!this.hasConfig(config, 'qiyeSsoURI')) {
            config.qiyeSsoURI = envConfigMap[env].qiyeSsoURI;
        }
        if (config.noEncryption || ((_c = config.authorizationEndpoint) === null || _c === void 0 ? void 0 : _c.endsWith('-public'))) {
            this.isNoEncryption = true;
        }
        // @FIXED focodesign.com 强制走 LocalStorage 模式
        if (host$1.includes('focodesign.com')) {
            config.tokenSourceType = TokenSourceType.LocalStorage;
        }
        /**
         * 如果有 xxxForce 则优先加载对应的  TokenSource
         * 否则为了适配跨端，则优先加载跨端的 TokenSource
         * 在后加载对应 tokenSourceType TokenSource （老的 tokenSourceType）
         * 最后默认加载 tokenSource 或 IframeTokenSource
         */
        if (!inBrowser) {
            this._tokenSource = new EmptyTokenSource();
        }
        else if (config.tokenSourceType === TokenSourceType.IframeForce) {
            this._tokenSource = new IframeTokenSource(this, env);
        }
        else if (config.tokenSourceType === TokenSourceType.LocalStorageForce) {
            this._tokenSource = new LocalStorageTokenSource(this);
        }
        else if (config.tokenSourceType === TokenSourceType.WebApp || platform.isApp) {
            this.config.endpoint = isAndroid() ? ENDPOINT.ANDROID : isIOS() ? ENDPOINT.IOS : ENDPOINT.H5;
            this._tokenSource = new AppTokenSource(this, config);
        }
        else if (config.tokenSourceType === TokenSourceType.Electron || platform.isGaodingPro) {
            this.config.endpoint = ENDPOINT.ELECTRON;
            this._tokenSource = new AppTokenSource(this, config); // App 和  Electron 使用 GNB 桥对接
        }
        else if (config.tokenSourceType === TokenSourceType.LocalStorage) {
            this._tokenSource = new LocalStorageTokenSource(this);
        }
        else if (config.tokenSourceType === TokenSourceType.Iframe) {
            this._tokenSource = new IframeTokenSource(this, env);
        }
        else if (config.tokenSourceType === TokenSourceType.Huaban) { // 花瓣平台
            this._tokenSource = new HuabanTokenSource(this);
        }
        else if (config.tokenSourceType === TokenSourceType.Memory) { // token 存内存，临时使用
            this._tokenSource = new MemoryTokenSource(this);
        }
        else if (config.tokenSource) {
            this._tokenSource = config.tokenSource;
        }
        else {
            this._tokenSource = new IframeTokenSource(this, env);
        }
        if (inBrowser) {
            window.__OAUTH2_CLIENT__ = this;
        }
        else {
            OAuth2Client.instance = this;
        }
        this.checkLogoutStatusEventListener();
        this.mergedAccountCheck();
    }
    /**
     * 一体化账号校验
     */
    OAuth2Client.prototype.mergedAccountCheck = function () {
        var _a, _b;
        var _isMergeAccount = this.config.isMergedAccount || isMergeAccount(this);
        if (!_isMergeAccount) {
            return;
        }
        var env = this.config.env || Env.Prod;
        // 判断是一体化 token ，tokenEndpoint 强制改为 tokenEndpointV3
        this.config.tokenEndpoint = envConfigMap[env].tokenEndpointV3;
        this.config.isMergedAccount = true;
        // // 花瓣平台一体化授权
        if (this.config.tokenSourceType === TokenSourceType.Huaban) {
            this._tokenSource = new HuabanTokenSourceV2(this);
        }
        // Iframe 模式也需要触发 mergedAccountCheck
        if (this.config.tokenSourceType === TokenSourceType.Iframe) {
            (_b = (_a = this._tokenSource) === null || _a === void 0 ? void 0 : _a.mergedAccountCheck) === null || _b === void 0 ? void 0 : _b.call(_a);
        }
    };
    OAuth2Client.prototype.open = function (options) {
        return new AuthManager$1(this, options);
    };
    OAuth2Client.prototype.openLogin = function (options) {
        var authManager = new AuthManager(this, options);
        if ((options === null || options === void 0 ? void 0 : options.target) === 'null') {
            return authManager.getOpenUrl();
        }
        return authManager.initWindow();
    };
    OAuth2Client.prototype.login = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    if (token) {
                        return [2 /*return*/, this.setToken(token)];
                    }
                }
                catch (error) {
                    return [2 /*return*/];
                }
                return [2 /*return*/];
            });
        });
    };
    OAuth2Client.prototype.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    window.localStorage.removeItem(AUTH_LOGOUT_STATUS);
                    return [2 /*return*/, this.clearToken()];
                }
                catch (error) {
                    return [2 /*return*/];
                }
                return [2 /*return*/];
            });
        });
    };
    OAuth2Client.prototype.getAccessToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var accessToken, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this._tokenSource.getAccessToken()];
                    case 1:
                        accessToken = _a.sent();
                        return [2 /*return*/, accessToken];
                    case 2:
                        error_1 = _a.sent();
                        return [2 /*return*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    OAuth2Client.prototype.getAccessTokenV2 = function () {
        return __awaiter(this, void 0, void 0, function () {
            var accessToken;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._tokenSource.getAccessToken()];
                    case 1:
                        accessToken = _a.sent();
                        return [2 /*return*/, accessToken];
                }
            });
        });
    };
    OAuth2Client.prototype.getToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var token, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this._tokenSource.getToken()];
                    case 1:
                        token = _a.sent();
                        return [2 /*return*/, token];
                    case 2:
                        error_2 = _a.sent();
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    OAuth2Client.prototype.setToken = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    return [2 /*return*/, this._tokenSource.setToken(this._sanitize(token))];
                }
                catch (error) {
                    return [2 /*return*/];
                }
                return [2 /*return*/];
            });
        });
    };
    OAuth2Client.prototype.setOrgId = function (org_id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    return [2 /*return*/, this._tokenSource.setOrgId(org_id)];
                }
                catch (error) {
                    return [2 /*return*/];
                }
                return [2 /*return*/];
            });
        });
    };
    OAuth2Client.prototype.getOrgId = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    return [2 /*return*/, this._tokenSource.getOrgId()];
                }
                catch (error) {
                    return [2 /*return*/, ''];
                }
                return [2 /*return*/];
            });
        });
    };
    OAuth2Client.prototype.setExtraData = function (key, data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    return [2 /*return*/, this._tokenSource.setExtraData(key, data)];
                }
                catch (error) {
                    return [2 /*return*/];
                }
                return [2 /*return*/];
            });
        });
    };
    OAuth2Client.prototype.getExtraData = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    return [2 /*return*/, this._tokenSource.getExtraData(key)];
                }
                catch (error) {
                    return [2 /*return*/];
                }
                return [2 /*return*/];
            });
        });
    };
    OAuth2Client.prototype.clearToken = function (state) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    return [2 /*return*/, this._tokenSource.clearToken(state)];
                }
                catch (error) {
                    return [2 /*return*/];
                }
                return [2 /*return*/];
            });
        });
    };
    OAuth2Client.prototype.getAuthorizationHeader = function () {
        return __awaiter(this, void 0, void 0, function () {
            var accessToken, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.getAccessToken()];
                    case 1:
                        accessToken = _a.sent();
                        if (accessToken) {
                            return [2 /*return*/, this._schema + " " + accessToken];
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_3 = _a.sent();
                        return [2 /*return*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    OAuth2Client.prototype.checkTokenStatus = function (checkOptions, error) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!error) return [3 /*break*/, 2];
                        return [4 /*yield*/, launchDialog(checkOptions, error)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                    case 2:
                        if (this.checkTokenStatusFlag) {
                            return [2 /*return*/];
                        }
                        // 调用 getAccessToken 尝试刷新 token（如果 token 过期的话）
                        this.checkTokenStatusFlag = true;
                        return [4 /*yield*/, this.getAccessToken()];
                    case 3:
                        _a.sent();
                        this.checkTokenStatusFlag = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    OAuth2Client.prototype.hasConfig = function (config, key) {
        return Object.prototype.hasOwnProperty.call(config, key);
    };
    OAuth2Client.prototype.checkLogoutStatusEventListener = function () {
        var _this = this;
        window.addEventListener("message", function (event) {
            var _a, _b;
            if (((_a = event.data) === null || _a === void 0 ? void 0 : _a.action) === 'checkLogoutStatus') {
                _this.checkLogoutStatus((_b = event.data) === null || _b === void 0 ? void 0 : _b.token);
            }
        }, false);
    };
    OAuth2Client.prototype.checkLogoutStatus = function (token) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var status, authorization_1, umsURI_1, destroyStatusApi, userDestroyRes, error_4;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        status = window.localStorage.getItem(AUTH_LOGOUT_STATUS);
                        if (!status) {
                            return [2 /*return*/];
                        }
                        if (!(token === null || token === void 0 ? void 0 : token.access_token)) {
                            return [2 /*return*/];
                        }
                        if (this.checkLogoutStatusFlag) {
                            return [2 /*return*/];
                        }
                        this.checkLogoutStatusFlag = true;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 4, , 5]);
                        authorization_1 = this._schema + " " + token.access_token;
                        umsURI_1 = envConfigMap[this.config.env || 'prod'].umsURI;
                        destroyStatusApi = this.config.isMergedAccount ? umsURI_1 + "/v3/api/users/destroy/status" : umsURI_1 + "/api/v2/users/destroy/status";
                        return [4 /*yield*/, http.get(destroyStatusApi, {
                                headers: {
                                    Authorization: authorization_1
                                }
                            })];
                    case 2:
                        userDestroyRes = _b.sent();
                        if (((_a = userDestroyRes === null || userDestroyRes === void 0 ? void 0 : userDestroyRes.data) === null || _a === void 0 ? void 0 : _a.status) !== USER_DESTROY_STATUS.Unregistering) {
                            window.localStorage.removeItem(AUTH_LOGOUT_STATUS);
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, logoutDialog({
                                cancel: function () { return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        this.logout();
                                        location.reload();
                                        return [2 /*return*/];
                                    });
                                }); },
                                ok: function () { return __awaiter(_this, void 0, void 0, function () {
                                    var destroyCancelApi;
                                    return __generator(this, function (_a) {
                                        destroyCancelApi = this.config.isMergedAccount ? umsURI_1 + "/v3/api/users/destroy/cancel" : umsURI_1 + "/api/v2/users/destroy/cancel";
                                        http.post(destroyCancelApi, null, {
                                            headers: {
                                                Authorization: authorization_1
                                            }
                                        }).then(function () {
                                            window.localStorage.removeItem(AUTH_LOGOUT_STATUS);
                                        }).catch(function (err) { });
                                        return [2 /*return*/];
                                    });
                                }); },
                            })];
                    case 3:
                        _b.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        error_4 = _b.sent();
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    OAuth2Client.prototype.launchPasswordCredentialsFlow = function (data, headers) {
        return __awaiter(this, void 0, void 0, function () {
            var passwordRequest, assignHeaders, response, token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        passwordRequest = new PasswordRequest(__assign({ grantType: 'password', clientId: this.config.clientId, clientSecret: this.config.clientSecret, os: getOS(), portal: this.config.portal }, data));
                        assignHeaders = this._assignHeaders(headers);
                        if (!this.isNoEncryption) return [3 /*break*/, 2];
                        return [4 /*yield*/, http.post(this.config.tokenEndpoint, passwordRequest.toSnakeCase(), { headers: assignHeaders })];
                    case 1:
                        response = _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, http.post(this.config.tokenEndpoint, { data: dataEncryption(passwordRequest.toSnakeCase()) }, {
                            headers: assignHeaders
                        })];
                    case 3:
                        response = _a.sent();
                        _a.label = 4;
                    case 4:
                        token = this._sanitize(response.data);
                        return [4 /*yield*/, this._tokenSource.setToken(token)];
                    case 5:
                        _a.sent();
                        return [2 /*return*/, token];
                }
            });
        });
    };
    OAuth2Client.prototype.launchVerifyCodeFlow = function (data, headers) {
        return __awaiter(this, void 0, void 0, function () {
            var verifyCodeRequest, assignHeaders, response, token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        verifyCodeRequest = new VerifyCodeRequest(__assign({ grantType: 'verify-code', clientId: this.config.clientId, clientSecret: this.config.clientSecret, os: getOS(), portal: this.config.portal }, data));
                        assignHeaders = this._assignHeaders(headers);
                        return [4 /*yield*/, http.post(this.config.tokenEndpoint, verifyCodeRequest.toSnakeCase(), {
                                headers: assignHeaders
                            })];
                    case 1:
                        response = _a.sent();
                        token = this._sanitize(response.data);
                        return [4 /*yield*/, this._tokenSource.setToken(token)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, token];
                }
            });
        });
    };
    /**
     * token 换 code
     * @param options
     * @returns
     */
    OAuth2Client.prototype.launchCodeAuthorizationFlow = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var openWindow, accessToken, umsURI, targetUrl, params;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        openWindow = windowRedirect(options.target || 'blank');
                        return [4 /*yield*/, this.getAccessToken()];
                    case 1:
                        accessToken = _a.sent();
                        if (!accessToken) {
                            return [2 /*return*/, openWindow(options.redirectUrl)];
                        }
                        umsURI = envConfigMap[this.config.env || 'prod'].umsURI;
                        targetUrl = options.url || umsURI + "/connect/oauth/authorize";
                        params = new URLSearchParams({
                            access_token: accessToken,
                            client_id: options.clientId || this.config.clientId,
                            redirect_uri: options.redirectUrl,
                            biz_code: options.bizCode || this.config.bizCode || '',
                            endpoint: options.endpoint || this.config.endpoint || '',
                            response_type: 'code',
                        });
                        return [2 /*return*/, openWindow(targetUrl + "?" + params.toString())];
                }
            });
        });
    };
    /**
     * 登录态同步：token 换 token
     * @param options
     * @returns
     */
    OAuth2Client.prototype.launchAuthorizationFlow = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var openWindow, accessToken, _URL, targetUrl, params;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        openWindow = windowRedirect(options.target || 'blank');
                        return [4 /*yield*/, this.getAccessToken()];
                    case 1:
                        accessToken = _a.sent();
                        if (!accessToken) {
                            return [2 /*return*/, openWindow(options.url)];
                        }
                        _URL = new URL(options.url);
                        targetUrl = _URL.origin + "/ums/cgi/login-sync";
                        params = new URLSearchParams({
                            access_token: accessToken,
                            redirect_url: options.url,
                            login_type: '',
                            prompt: ''
                        });
                        return [2 /*return*/, openWindow(targetUrl + "?" + params.toString())];
                }
            });
        });
    };
    /**
     * code 换 token
     * @param data
     * @param headers
     * @returns
     */
    OAuth2Client.prototype.launchAuthorizationCodeFlow = function (data, headers) {
        return __awaiter(this, void 0, void 0, function () {
            var authorizationCodeRequest, assignHeaders, response, token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        authorizationCodeRequest = new AuthorizationCodeRequest(__assign({ grantType: 'authorization_code', clientId: this.config.clientId, clientSecret: this.config.clientSecret, os: getOS(), portal: this.config.portal }, data));
                        assignHeaders = this._assignHeaders(headers);
                        return [4 /*yield*/, http.post(this.config.tokenEndpoint, authorizationCodeRequest.toSnakeCase(), {
                                headers: assignHeaders
                            })];
                    case 1:
                        response = _a.sent();
                        token = this._sanitize(response.data);
                        return [4 /*yield*/, this._tokenSource.setToken(token)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, token];
                }
            });
        });
    };
    OAuth2Client.prototype.launchThirdPartyFlow = function (data, headers) {
        return __awaiter(this, void 0, void 0, function () {
            var thirdPartyRequest, assignHeaders, response, token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        thirdPartyRequest = new ThirdPartyRequest(__assign({ clientId: this.config.clientId, clientSecret: this.config.clientSecret, os: getOS(), portal: this.config.portal }, data));
                        assignHeaders = this._assignHeaders(headers);
                        return [4 /*yield*/, http.post(this.config.tokenEndpoint, thirdPartyRequest.toSnakeCase(), {
                                headers: assignHeaders
                            })];
                    case 1:
                        response = _a.sent();
                        token = this._sanitize(response.data);
                        return [4 /*yield*/, this._tokenSource.setToken(token)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, token];
                }
            });
        });
    };
    OAuth2Client.prototype.launchRefreshTokenFlow = function (data, headers) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var refreshTokenRequest, response, assignHeaders, token;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        refreshTokenRequest = new RefreshTokenRequest(__assign({ grantType: 'refresh_token', clientId: this.config.clientId, clientSecret: this.config.clientSecret, os: getOS(), portal: this.config.portal }, data));
                        assignHeaders = this._assignHeaders(headers);
                        if (!(this.config.tokenMethod === 'post')) return [3 /*break*/, 2];
                        return [4 /*yield*/, http.post(this.config.tokenEndpoint, refreshTokenRequest.toSnakeCase(), {
                                headers: assignHeaders
                            })];
                    case 1:
                        response = _b.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, http.get(this.config.tokenEndpoint, {
                            params: refreshTokenRequest.toSnakeCase(),
                            headers: assignHeaders
                        })];
                    case 3:
                        response = _b.sent();
                        _b.label = 4;
                    case 4:
                        token = this._sanitize(response.data);
                        if ((_a = window === null || window === void 0 ? void 0 : window.parent) === null || _a === void 0 ? void 0 : _a.postMessage) {
                            window.parent.postMessage({ action: 'checkLogoutStatus', token: token }, '*');
                        }
                        else {
                            this.checkLogoutStatus(token);
                        }
                        return [2 /*return*/, token];
                }
            });
        });
    };
    OAuth2Client.prototype.authorizationRedirectURI = function (state, extendQuery) {
        if (state === void 0) { state = ''; }
        if (extendQuery === void 0) { extendQuery = {}; }
        if (!this.config.redirectURI) {
            throw new Error('redirectURI is required.');
        }
        var query = __assign(__assign({}, extendQuery), { tokenKey: this.config.scopeToken ? this.config.clientId + "." + TOKEN_KEY : this.config.tokenKey, appid: this.config.clientId, redirect_uri: this.config.redirectURI, referer_uri: this.config.ssoRedirectURI, state: state, guest_token: this.config.deviceId || getUserDeviceId() });
        var redirectUrl = this.config.authorizationEndpoint + "?" + qs.stringify(query);
        console.log(redirectUrl, 'authorizationRedirectURI');
        return redirectUrl;
    };
    /**
     * 刷 org_id
     * https://doc.huanleguang.com/pages/viewpage.action?pageId=201254336
     * @param data
     * @param headers
     */
    OAuth2Client.prototype.launchreRreshOrgIdFlow = function (data) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                if (((_a = this.config) === null || _a === void 0 ? void 0 : _a.tokenSourceType) === TokenSourceType.Huaban) {
                    return [2 /*return*/, this.huabanLaunchreRreshOrgIdFlow(data)];
                }
                return [2 /*return*/, this.defaultLaunchreRreshOrgIdFlow(data)];
            });
        });
    };
    OAuth2Client.prototype.huabanLaunchreRreshOrgIdFlow = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var _org_id, formData, channelId, refreshOrgIdRequest, accessToken, assignHeaders, headers, response, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _org_id = '';
                        if (!!(data && data.org_id)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getOrgId()];
                    case 1:
                        _org_id = _a.sent();
                        _a.label = 2;
                    case 2:
                        formData = Object.assign({ org_id: _org_id, }, data);
                        channelId = (data === null || data === void 0 ? void 0 : data.channel_id) || this.config.channelId;
                        refreshOrgIdRequest = new RefreshOrgIdRequest(__assign({}, formData));
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 7, , 8]);
                        return [4 /*yield*/, this.getAccessToken()];
                    case 4:
                        accessToken = _a.sent();
                        assignHeaders = this._assignHeaders();
                        headers = __assign({ 'X-Channel-Id': channelId }, assignHeaders);
                        if (accessToken) {
                            // @ts-ignore
                            headers.Authorization = "Bearer " + accessToken;
                        }
                        return [4 /*yield*/, http.put(this.config.webRequireURI + "/me/orgs", refreshOrgIdRequest.toSnakeCase(), {
                                headers: headers
                            })];
                    case 5:
                        response = _a.sent();
                        return [4 /*yield*/, this._tokenSource.setOrgId(data.org_id)];
                    case 6:
                        _a.sent();
                        return [2 /*return*/, response];
                    case 7:
                        error_5 = _a.sent();
                        return [2 /*return*/, null];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    OAuth2Client.prototype.defaultLaunchreRreshOrgIdFlow = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var _org_id, token, formData, channelId, refreshOrgIdRequest, assignHeaders, response, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _org_id = '';
                        return [4 /*yield*/, this.getToken()];
                    case 1:
                        token = _a.sent();
                        if (!!(data && data.org_id)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.getOrgId()];
                    case 2:
                        _org_id = _a.sent();
                        _a.label = 3;
                    case 3:
                        formData = Object.assign({
                            org_id: _org_id,
                            access_token: (token === null || token === void 0 ? void 0 : token.access_token) || '',
                            refresh_token: (token === null || token === void 0 ? void 0 : token.refresh_token) || ''
                        }, data);
                        channelId = (data === null || data === void 0 ? void 0 : data.channel_id) || this.config.channelId;
                        refreshOrgIdRequest = new RefreshOrgIdRequest(__assign({}, formData));
                        assignHeaders = this._assignHeaders();
                        _a.label = 4;
                    case 4:
                        _a.trys.push([4, 7, , 8]);
                        return [4 /*yield*/, http.post(this.config.qiyeSsoURI + "/api/token/org-bind", refreshOrgIdRequest.toSnakeCase(), {
                                headers: __assign({ 'X-Channel-Id': channelId }, assignHeaders)
                            })];
                    case 5:
                        response = _a.sent();
                        return [4 /*yield*/, this._tokenSource.setOrgId(data.org_id)];
                    case 6:
                        _a.sent();
                        return [2 /*return*/, response];
                    case 7:
                        error_6 = _a.sent();
                        return [2 /*return*/, null];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * token 解绑 org_id
     * https://yapi.gaoding.com/project/202/interface/api/170202
     * @param data
     * @param headers
     */
    OAuth2Client.prototype.launchreUnbindOrgIdFlow = function (data) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                if (((_a = this.config) === null || _a === void 0 ? void 0 : _a.tokenSourceType) === TokenSourceType.Huaban) {
                    return [2 /*return*/, this.huabanLaunchreUnbindOrgIdFlow(data)];
                }
                return [2 /*return*/, this.defaultLaunchreUnbindOrgIdFlow(data)];
            });
        });
    };
    OAuth2Client.prototype.huabanLaunchreUnbindOrgIdFlow = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var refreshOrgIdRequest, channelId, accessToken, assignHeaders, headers, response, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        refreshOrgIdRequest = new RefreshOrgIdRequest(__assign({}, data));
                        channelId = (data === null || data === void 0 ? void 0 : data.channel_id) || this.config.channelId;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this.getAccessToken()];
                    case 2:
                        accessToken = _a.sent();
                        assignHeaders = this._assignHeaders();
                        headers = __assign({ 'X-Channel-Id': channelId }, assignHeaders);
                        if (accessToken) {
                            // @ts-ignore
                            headers.Authorization = "Bearer " + accessToken;
                        }
                        return [4 /*yield*/, http.delete(this.config.webRequireURI + "/me/orgs", {
                                data: refreshOrgIdRequest.toSnakeCase(),
                                headers: headers
                            })];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 4:
                        error_7 = _a.sent();
                        return [2 /*return*/, null];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    OAuth2Client.prototype.defaultLaunchreUnbindOrgIdFlow = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var token, formData, refreshOrgIdRequest, assignHeaders, channelId, response, error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getToken()];
                    case 1:
                        token = _a.sent();
                        formData = Object.assign({
                            access_token: (token === null || token === void 0 ? void 0 : token.access_token) || '',
                            refresh_token: (token === null || token === void 0 ? void 0 : token.refresh_token) || ''
                        }, data);
                        refreshOrgIdRequest = new RefreshOrgIdRequest(__assign({}, formData));
                        assignHeaders = this._assignHeaders();
                        channelId = (data === null || data === void 0 ? void 0 : data.channel_id) || this.config.channelId;
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, http.delete(this.config.qiyeSsoURI + "/api/token/org-bind", {
                                data: refreshOrgIdRequest.toSnakeCase(),
                                headers: __assign({ 'X-Channel-Id': channelId }, assignHeaders)
                            })];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 4:
                        error_8 = _a.sent();
                        return [2 /*return*/, null];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    OAuth2Client.prototype.launchreClearToken = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var assignHeaders, error_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!data.access_token) {
                            return [2 /*return*/, true];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        assignHeaders = this._assignHeaders({
                            'x-appid': this.config.clientId,
                            Authorization: "Bearer " + data.access_token
                        });
                        return [4 /*yield*/, http.delete(this.config.tokenEndpoint, { headers: assignHeaders })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_9 = _a.sent();
                        if (error_9 && error_9.status && error_9.status >= 499) {
                            return [2 /*return*/, false];
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, true];
                }
            });
        });
    };
    OAuth2Client.prototype._sanitize = function (data) {
        return {
            access_token: data.access_token,
            expires_in: data.expires_in,
            access_token_expires_at: data.access_token_expires_at,
            access_token_life_time: data.access_token_life_time,
            refresh_token: data.refresh_token,
            refresh_token_expires_in: data.refresh_token_expires_in,
            refresh_token_expires_at: data.refresh_token_expires_at,
            refresh_token_life_time: data.refresh_token_life_time,
            ticket: data.ticket,
            org_id: data.org_id,
            merged: data.merged,
            timestamp: Date.now()
        };
    };
    OAuth2Client.prototype._assignHeaders = function (headers) {
        var headersConfig = {};
        if (this.config.deviceId) {
            headersConfig['X-Guest-Token'] = this.config.deviceId;
        }
        if (this.config.deviceId) {
            headersConfig['X-Device-Id'] = this.config.deviceId;
        }
        if (this.config.bizCode) {
            headersConfig['X-Biz-Code'] = this.config.bizCode;
        }
        if (this.config.endpoint) {
            headersConfig['X-Endpoint'] = this.config.endpoint;
        }
        function toLowerCase(obj) {
            if (typeof obj !== 'object') {
                return {};
            }
            return Object.keys(obj).reduce(function (acc, key) {
                acc[key.toLowerCase()] = obj[key];
                return acc;
            }, {});
        }
        return Object.assign({}, toLowerCase(this._defaultHeadersConfig), toLowerCase(headersConfig), toLowerCase(headers));
    };
    OAuth2Client.prototype._log = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        if (this.debug) {
            console.log.apply(console, __spreadArrays(["[OAuth2Client] " + message], optionalParams));
        }
    };
    return OAuth2Client;
}());

export { Env, HUABAN_ACCESS_TOKEN_KEY, OAuth2Client, TokenSourceType };
